webpackJsonp([1],{

/***/ "+Ai8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eventCreationPrompt_vue__ = __webpack_require__("S7gw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eventCreationPrompt_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eventCreationPrompt_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eventCreationPrompt_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eventCreationPrompt_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74bc6182_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_eventCreationPrompt_vue__ = __webpack_require__("vAWj");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("/kDo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74bc6182"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_eventCreationPrompt_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74bc6182_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_eventCreationPrompt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/dashboard/eventCreationPrompt.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-74bc6182", Component.options)
  } else {
    hotAPI.reload("data-v-74bc6182", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "+FOJ":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("F5Kl");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("278ce82b", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-815962b4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./scheduler.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-815962b4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./scheduler.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "+TLm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _luxon = __webpack_require__("H9QG");

exports.default = {
  props: {
    periods: {
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      event: null,
      tickIntervalSeconds: 60 * 60
    };
  },

  computed: {
    dates: function dates() {
      var result = [];
      if (this.event) {
        var s = this.event.start;
        while (s <= this.event.end) {
          result.push(s);
          s = s.plus({ days: 1 });
        }
      }
      return result;
    },
    visibleDates: function visibleDates() {
      var _this = this;

      return this.dates.filter(function (d) {
        for (var i = 0; i < _this.periods.length; i++) {
          var period = _this.periods[i];
          if (period.start.hasSame(d, "day")) {
            return true;
          }
          if (period.end.hasSame(d, "day")) {
            return true;
          } else {
            return false;
          }
        }
      });
    },
    rooms: function rooms() {
      return this.event.details.rooms;
    },
    visibleRooms: function visibleRooms() {
      var roomPeriodIds = this.periods.map(function (p) {
        return p.room;
      });
      return this.rooms.filter(function (r) {
        return roomPeriodIds.indexOf(r.id) !== -1;
      });
    },
    dateStrings: function dateStrings() {
      return this.visibleDates.map(function (d) {
        return d.toFormat("DD");
      });
    },
    tickTimes: function tickTimes() {
      var result = [];
      var s = this.event.start;
      var e = this.event.start.endOf("day");
      while (s <= e) {
        result.push(s);
        s = s.plus({ seconds: this.tickIntervalSeconds });
      }
      return result;
    },
    tickTimeStrings: function tickTimeStrings() {
      return this.tickTimes.map(function (t) {
        return t.toLocaleString(_luxon.DateTime.TIME_SIMPLE);
      });
    }
  },
  methods: {
    periodBelongs: function periodBelongs(period, date, room, tick) {
      var tickRange = _luxon.Interval.fromDateTimes(tick, tick.plus({ seconds: this.tickIntervalSeconds }));
      var periodRange = _luxon.Interval.fromDateTimes(period.start, period.end);
      return period.start.hasSame(date, "day") && period.room == room.id && tickRange.overlaps(periodRange);
    },

    calcPeriodPosition: function calcPeriodPosition(period, tick) {
      var tickRange = _luxon.Interval.fromDateTimes(tick, tick.plus({ seconds: this.tickIntervalSeconds }));
      var periodRange = _luxon.Interval.fromDateTimes(period.start, period.end);
      if (periodRange.start <= tickRange.start) {
        return "top";
      } else if (periodRange.end >= tickRange.end) {
        return "bottom";
      } else {
        return "middle";
      }
    },
    calcPeriodHeight: function calcPeriodHeight(period, tick) {
      var tickRange = _luxon.Interval.fromDateTimes(tick, tick.plus({ seconds: this.tickIntervalSeconds }));
      var periodRange = _luxon.Interval.fromDateTimes(period.start, period.end);
      var overlap = tickRange.intersection(periodRange).length("seconds");

      var heightPercent = overlap / this.tickIntervalSeconds;
      return heightPercent > 1 ? 100 : heightPercent * 100;
    }
  },
  beforeMount: function beforeMount() {
    this.event = this.$store.getters.event();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "+cgv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+pr7":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.header[data-v-29e8c3c6] {\n  flex-grow: 0;\n  flex-shrink: 0;\n  height: 45px;\n  font-family: \"League Spartan\", sans-serif;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 18px 32px;\n  background: #f2f3fd;\n  color: #2a2e51;\n}\n.header > div[data-v-29e8c3c6] {\n    display: flex;\n    align-items: center;\n}\nh2[data-v-29e8c3c6] {\n  margin: 0px 18px;\n}\nh3[data-v-29e8c3c6] {\n  margin: 0px 12px;\n}\n", ""]);

// exports


/***/ }),

/***/ "/8fb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/TLO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("fEDi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52077837_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("qQYN");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("fx46")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52077837"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52077837_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/dashboard/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-52077837", Component.options)
  } else {
    hotAPI.reload("data-v-52077837", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/kDo":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("L92P");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("4d69c58d", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-74bc6182\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./eventCreationPrompt.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-74bc6182\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./eventCreationPrompt.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "14ux":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_details_vue__ = __webpack_require__("O9dY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_details_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_details_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_details_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_details_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_067a7d6d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_details_vue__ = __webpack_require__("dTeq");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("K+Ie")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-067a7d6d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_details_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_067a7d6d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/event/details.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-067a7d6d", Component.options)
  } else {
    hotAPI.reload("data-v-067a7d6d", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2dpn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2oC0":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.scheduler-body[data-v-8888eb08] {\n  display: flex;\n  flex-direction: row;\n  flex-grow: 1;\n}\n.scheduler-body > div[data-v-8888eb08]:first-child {\n    width: 250px;\n    border: 1px solid grey;\n}\n.scheduler-body > div[data-v-8888eb08]:last-child {\n    flex-grow: 1;\n    position: relative;\n}\n.room-edit-field[data-v-8888eb08] {\n  margin: 8px 12px;\n}\n", ""]);

// exports


/***/ }),

/***/ "2qVX":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("56Zg");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("4c02539e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-10d9df09\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./login.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-10d9df09\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./login.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "39ur":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _session = __webpack_require__("PSx8");

var _session2 = _interopRequireDefault(_session);

var _login = __webpack_require__("K31e");

var _login2 = _interopRequireDefault(_login);

var _header = __webpack_require__("Cz8s");

var _header2 = _interopRequireDefault(_header);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vCalendar = __webpack_require__("sY/S");

var _vCalendar2 = _interopRequireDefault(_vCalendar);

__webpack_require__("xWv6");

var _veeValidate = __webpack_require__("sUu7");

var _veeValidate2 = _interopRequireDefault(_veeValidate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_veeValidate2.default); //
//
//
//
//
//
//
//

_vue2.default.use(_vCalendar2.default);

exports.default = {
  name: "app",
  data: function data() {
    return {
      session: _session2.default
    };
  },

  computed: {
    showLoginPrompt: function showLoginPrompt() {
      return this.$route.meta.showLoginPrompt;
    }
  },
  components: {
    login: _login2.default,
    appHeader: _header2.default
  }
};

/***/ }),

/***/ "3f40":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "41C8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("M4fF");

function getEnv() {
  if (location.hostname.includes("localhost")) {
    return "localdev";
  } else if (location.hostname.includes("192")) {
    return "localdev";
  } else if (location.hostname.includes("development")) {
    return "development";
  } else if (location.hostname.includes("production")) {
    return "production";
  } else {
    return "production";
  }
}
function parseConfig(env) {
  var cfgBase = __webpack_require__("8/ZA");
  var cfg = __webpack_require__("DYWz")("./config." + env + ".json");
  return (0, _lodash.merge)(cfgBase, cfg);
}

function setup() {
  return parseConfig(getEnv());
}

exports.default = setup();

/***/ }),

/***/ "469Z":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("2oC0");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("54f6f1c5", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8888eb08\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./schedule.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8888eb08\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./schedule.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "47bv":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("HIWr");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("1e9bf522", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3d0b1749\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./profile.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3d0b1749\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./profile.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "4Vh3":
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ "4qOc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "56Zg":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "5xgh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_attendeeCreate_vue__ = __webpack_require__("Xv87");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_attendeeCreate_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_attendeeCreate_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_attendeeCreate_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_attendeeCreate_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d86e4e0a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_attendeeCreate_vue__ = __webpack_require__("nUwj");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("o7P2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d86e4e0a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_attendeeCreate_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d86e4e0a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_attendeeCreate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/event/attendeeCreate.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d86e4e0a", Component.options)
  } else {
    hotAPI.reload("data-v-d86e4e0a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "6Mk+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [_vm._v("Login")]),
    _vm._v(" "),
    _c("form", { attrs: { action: "javascript:void(0);" } }, [
      _c("label", [_vm._v("Email Address:")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.formEmail,
            expression: "formEmail"
          }
        ],
        attrs: { type: "text" },
        domProps: { value: _vm.formEmail },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.formEmail = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("label", [_vm._v("Password:")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.formPassword,
            expression: "formPassword"
          }
        ],
        attrs: { type: "password" },
        domProps: { value: _vm.formPassword },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.formPassword = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-secondary",
          on: {
            click: function($event) {
              _vm.login()
            }
          }
        },
        [_vm._v("Log In")]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loginSuccess === false,
              expression: "loginSuccess===false"
            }
          ]
        },
        [_vm._v("Double check your email/password")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10d9df09", esExports)
  }
}

/***/ }),

/***/ "6ZSt":
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ "7R9x":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _luxon = __webpack_require__("H9QG");

var _miniScheduler = __webpack_require__("LIpS");

var _miniScheduler2 = _interopRequireDefault(_miniScheduler);

var _vueSelect = __webpack_require__("T1ft");

var _vueSelect2 = _interopRequireDefault(_vueSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    id: {},
    rooms: {
      default: function _default() {
        return [];
      }
    },
    editingPeriod: {
      default: function _default() {
        return null;
      }
    },
    editorVisible: {
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      input: {
        title: "",
        start: "",
        end: "",
        room: ""
      },
      stepSizeSeconds: 600,
      recurrences: []
    };
  },

  computed: {
    miniPeriods: function miniPeriods() {
      return this.recurrences.concat([this.editingPeriod]);
    },

    ticks: function ticks() {
      if (this.editingPeriod) {
        var start = this.editingPeriod.start;
      }
      var startDay = start.day;
      var result = [];
      while (start.day === startDay) {
        result.push([start, start.toLocaleString(_luxon.DateTime.TIME_SIMPLE)]);
        start = start.plus({ seconds: this.stepSizeSeconds });
      }
      return result;
    },
    roomOptions: function roomOptions() {
      return this.rooms.concat([{ name: 'none', id: null }]);
    }
  },
  methods: {
    addRecurrence: function addRecurrence() {
      this.recurrences.push({
        start: this.editingPeriod.start,
        end: this.editingPeriod.end,
        room: this.editingPeriod.room
      });
    },
    closeEditor: function closeEditor() {
      this.$emit("update:editingPeriod", null);
    },
    setInputFields: function setInputFields() {
      if (this.editingPeriod) {
        this.input.title = this.editingPeriod.title;
        this.input.start = this.editingPeriod.start;
        this.input.end = this.editingPeriod.end;
        this.input.room = this.editingPeriod.room;
      }
    },
    save: function save() {
      if (this.editingPeriod.unsaved) {
        this.$emit("periodAdded", this.input);
      } else {
        this.$emit("periodUpdated", this.input);
      }
    },
    removePeriod: function removePeriod() {
      this.$emit("periodRemoved", this.editingPeriod);
    }
  },
  watch: {
    editingPeriod: {
      deep: true,
      handler: function handler(v) {
        this.setInputFields();
      }
    }
  },
  components: {
    vSelect: _vueSelect2.default,
    miniScheduler: _miniScheduler2.default
  },
  beforeMount: function beforeMount() {
    this.setInputFields();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "8/ZA":
/***/ (function(module, exports) {

module.exports = {"apiBaseUrl":null,"flinkLibraryUrl":null}

/***/ }),

/***/ "8ISW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aGrid_vue__ = __webpack_require__("XKi2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aGrid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aGrid_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aGrid_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aGrid_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87dc9032_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aGrid_vue__ = __webpack_require__("HQfR");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("IDEl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-87dc9032"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_aGrid_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87dc9032_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_aGrid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/aGrid.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-87dc9032", Component.options)
  } else {
    hotAPI.reload("data-v-87dc9032", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "8YCc":
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ "8xEJ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.notification[data-v-ab78508e] {\n  background: #fcfcff;\n  margin: 18px 0px;\n  border-radius: 4px;\n  min-height: 60px;\n  width: 100%;\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  box-shadow: 0 0 2px rgba(34, 25, 25, 0.6);\n}\n.notification .icon-cont[data-v-ab78508e] {\n    color: #fcfcff;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 1.9rem;\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n    width: 60px;\n    background: #2a2e51;\n}\n.notification .body-cont[data-v-ab78508e] {\n    display: flex;\n    flex-grow: 1;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 18px;\n    line-height: 120%;\n    color: #2a2e51;\n}\n", ""]);

// exports


/***/ }),

/***/ "9Cbw":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("MzF/");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("587334c7", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-63fc1178\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./home.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-63fc1178\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=1!./home.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "9Geh":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.mask[data-v-d86e4e0a] {\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.body[data-v-d86e4e0a] {\n  width: 60vw;\n  min-width: 800px;\n  background: #f2f3fd;\n  padding: 12px 32px;\n  max-height: 80vh;\n  overflow-y: auto;\n}\n", ""]);

// exports


/***/ }),

/***/ "9up4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_attendeeDetail_vue__ = __webpack_require__("IWiR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_attendeeDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_attendeeDetail_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_attendeeDetail_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_attendeeDetail_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04679dd0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_attendeeDetail_vue__ = __webpack_require__("I2vD");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("CUSx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04679dd0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_attendeeDetail_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04679dd0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_attendeeDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/event/attendeeDetail.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-04679dd0", Component.options)
  } else {
    hotAPI.reload("data-v-04679dd0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "AGW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "expand-button" }, [
    _c("div", { staticClass: "expand-button-header" }, [_vm._t("header")], 2),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.expanded,
            expression: "expanded"
          }
        ],
        staticClass: "expand-button-body"
      },
      [_vm._t("body")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48495f08", esExports)
  }
}

/***/ }),

/***/ "AVDo":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("8xEJ");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("8846af00", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ab78508e\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./notificationList.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ab78508e\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./notificationList.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "B60+":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.dashboard-container[data-v-63fc1178] {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n.dashboard-header[data-v-63fc1178] {\n  flex-shrink: 0;\n  background: white;\n  color: #2a2e51;\n  border-bottom: 1px solid #b1b4cd;\n  border-top: 6px solid #2b8588;\n}\n.dashboard-header .profile-btn[data-v-63fc1178] {\n    color: #fb8609;\n    padding: 8px 16px;\n    border-radius: 4px;\n    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);\n    font-size: 2rem;\n}\n.dashboard-header .header-upper[data-v-63fc1178] {\n    padding: 4px 32px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n.dashboard-header .header-upper h2[data-v-63fc1178] {\n      letter-spacing: 6px;\n}\n.dashboard-header .header-lower[data-v-63fc1178] {\n    margin-top: 16px;\n    font-weight: 800;\n    font-size: 2.2rem;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n}\n.dashboard-header .header-lower > span[data-v-63fc1178] {\n      margin: 0px 24px;\n}\n.dashboard-header .header-nav[data-v-63fc1178] {\n    margin-top: 48px;\n    font-size: 1.2rem;\n    font-weight: 800;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n}\n.dashboard-header .header-nav > div[data-v-63fc1178] {\n      margin: 0px 30px;\n      padding: 0px 24px;\n}\n.dashboard-header .header-nav > div[data-v-63fc1178]:hover {\n      color: #2b8588;\n      border-bottom: 6px solid #2b8588;\n}\n.dashboard-header .header-nav .selected[data-v-63fc1178] {\n      color: #2b8588;\n      border-bottom: 6px solid #2b8588;\n}\n.body[data-v-63fc1178] {\n  color: #2a2e51;\n  padding: 0px 20px 0px 20px;\n  background: white;\n  border-radius: 4px;\n  border: 1px solid #b1b4cd;\n}\n.heads-up-list[data-v-63fc1178] {\n  flex-shrink: 0;\n}\n.mini-schedule[data-v-63fc1178] {\n  flex-grow: 1;\n  margin-right: 32px;\n  max-height: 400px;\n  overflow-y: auto;\n}\n", ""]);

// exports


/***/ }),

/***/ "BmU7":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.mini-sched-container[data-v-0d9ebe0f] {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  height: 250px;\n  overflow-y: auto;\n}\n.mini-sched-container > div[data-v-0d9ebe0f]:last-child {\n    display: flex;\n    flex-direction: column;\n    flex: 1 0 0;\n}\n.mini-sched-container > div:last-child > div[data-v-0d9ebe0f]:last-child {\n      flex: 1 0 0;\n}\n.timeline[data-v-0d9ebe0f] {\n  margin-top: 51px;\n  font-size: 0.5rem;\n  width: 50px;\n  flex-shrink: 0;\n}\n.tick[data-v-0d9ebe0f] {\n  height: 20px;\n  display: flex;\n  align-items: flex-start;\n  line-height: 0px;\n}\n.tick .label[data-v-0d9ebe0f] {\n    margin: 0px 4px;\n}\n.tick .spacer[data-v-0d9ebe0f] {\n    background: #b1b4cd;\n    height: 1px;\n    flex-grow: 1;\n}\n.mini-sched-header[data-v-0d9ebe0f] {\n  display: flex;\n  height: 30px;\n  flex-shrink: 0;\n  flex-grow: 0;\n}\n.mini-sched-header > div[data-v-0d9ebe0f] {\n    min-width: 100px;\n    font-size: 0.8rem;\n    border: 1px solid #b1b4cd;\n    text-align: center;\n    flex: 1 0 0;\n}\n.mini-sched-body[data-v-0d9ebe0f] {\n  display: flex;\n}\n.mini-sched-body > div[data-v-0d9ebe0f] {\n    flex: 1 0 0;\n    border: 1px solid #b1b4cd;\n    text-align: center;\n}\n.column[data-v-0d9ebe0f] {\n  display: flex;\n  flex-direction: column;\n}\n.column > div[data-v-0d9ebe0f]:first-child {\n  display: flex;\n  height: 20px;\n  flex-shrink: 0;\n  flex-grow: 0;\n  font-size: 0.7rem;\n}\n.column > div:first-child > div[data-v-0d9ebe0f] {\n    flex: 1 0 0;\n    min-width: 100px;\n}\n.column > div[data-v-0d9ebe0f]:last-child {\n  flex: 1 0 0;\n  display: flex;\n}\n.track[data-v-0d9ebe0f] {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  border-top: 1px solid #b1b4cd;\n}\n.track[data-v-0d9ebe0f]:not(:first-child) {\n  border-left: 1px dotted #b1b4cd;\n}\n.period[data-v-0d9ebe0f] {\n  width: 100%;\n  background: #2a2e51;\n}\n.period.bottom[data-v-0d9ebe0f] {\n  align-self: flex-end;\n}\n.period.top[data-v-0d9ebe0f] {\n  align-self: flex-start;\n}\n", ""]);

// exports


/***/ }),

/***/ "CJVD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      [
        _vm.session.contents
          ? [
              _c(
                "h3",
                [_c("router-link", { attrs: { to: "/" } }, [_vm._v("Home")])],
                1
              ),
              _vm._v(" "),
              _c(
                "h3",
                [
                  _c("router-link", { attrs: { to: "/profile" } }, [
                    _vm._v("Profile")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "h3",
                {
                  on: {
                    click: function($event) {
                      _vm.logout()
                    }
                  }
                },
                [_vm._v("Logout")]
              )
            ]
          : [
              _c(
                "h3",
                [
                  _c("router-link", { attrs: { to: "/login" } }, [
                    _vm._v("Login")
                  ])
                ],
                1
              )
            ]
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h2", [_vm._v("Anvil")]),
      _vm._v(" "),
      _c("h3", [_vm._v("Link 1")]),
      _vm._v(" "),
      _c("h3", [_vm._v("Link 2")]),
      _vm._v(" "),
      _c("h3", [_vm._v("Link 3")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29e8c3c6", esExports)
  }
}

/***/ }),

/***/ "CNCi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_schedule_vue__ = __webpack_require__("dMSp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_schedule_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_schedule_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_schedule_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_schedule_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8888eb08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_schedule_vue__ = __webpack_require__("PdHH");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("469Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8888eb08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_schedule_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8888eb08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_schedule_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/event/schedule.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8888eb08", Component.options)
  } else {
    hotAPI.reload("data-v-8888eb08", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "CUSx":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("lPPF");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("4c4248a4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-04679dd0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./attendeeDetail.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-04679dd0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./attendeeDetail.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "ClqJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_attendees_vue__ = __webpack_require__("kg7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_attendees_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_attendees_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_attendees_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_attendees_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bc7ec38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_attendees_vue__ = __webpack_require__("Jmf0");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("pg1t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2bc7ec38"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_attendees_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bc7ec38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_attendees_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/event/attendees.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2bc7ec38", Component.options)
  } else {
    hotAPI.reload("data-v-2bc7ec38", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Cz8s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__("wqBJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29e8c3c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("CJVD");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("FYvM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-29e8c3c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29e8c3c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/header.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-29e8c3c6", Component.options)
  } else {
    hotAPI.reload("data-v-29e8c3c6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "D46J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_scheduler_vue__ = __webpack_require__("Kyh9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_scheduler_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_scheduler_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_scheduler_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_scheduler_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_815962b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_scheduler_vue__ = __webpack_require__("VUAA");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("+FOJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-815962b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_scheduler_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_815962b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_scheduler_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/event/scheduler.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-815962b4", Component.options)
  } else {
    hotAPI.reload("data-v-815962b4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "DBS9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signup_vue__ = __webpack_require__("z5BB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signup_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signup_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signup_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56bbef28_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signup_vue__ = __webpack_require__("zoXK");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("pimq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56bbef28"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signup_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56bbef28_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/signup.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-56bbef28", Component.options)
  } else {
    hotAPI.reload("data-v-56bbef28", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "DYWz":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./config.base.json": "8/ZA",
	"./config.development.json": "tTI2",
	"./config.localdev.json": "NrRE",
	"./config.production.json": "WVLx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DYWz";

/***/ }),

/***/ "EiCj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expandButton_vue__ = __webpack_require__("vUcl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expandButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expandButton_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expandButton_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expandButton_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48495f08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_expandButton_vue__ = __webpack_require__("AGW7");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("s+vn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48495f08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expandButton_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48495f08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_expandButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/expandButton.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-48495f08", Component.options)
  } else {
    hotAPI.reload("data-v-48495f08", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "F5Kl":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.scheduler-container[data-v-815962b4] {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.scheduler-scroll-container[data-v-815962b4] {\n  overflow: auto;\n  flex: 1 0 0;\n}\n.schedule-header[data-v-815962b4] {\n  margin-left: 50px;\n  color: #2a2e51;\n  display: flex;\n}\n.schedule-header > div[data-v-815962b4] {\n  text-align: center;\n  background: #f2f3fd;\n  border-right: 1px solid #b1b4cd;\n  flex-grow: 1;\n}\n.schedule-container[data-v-815962b4] {\n  height: 800px;\n  display: flex;\n  flex-direction: row;\n}\n.schedule-timeline[data-v-815962b4] {\n  height: 100%;\n  font-size: 0.6rem;\n  color: black;\n  width: 50px;\n  background: white;\n  border-right: 1px solid black;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  text-align: center;\n}\n.schedule-timeline > div[data-v-815962b4] {\n  width: 100%;\n  flex: 1;\n  border-top: 1px solid black;\n}\n.schedule-column[data-v-815962b4] {\n  flex-grow: 1;\n  height: 100%;\n  background: white;\n  color: black;\n  position: relative;\n  border-right: 1px solid #b1b4cd;\n  touch-action: none;\n}\n.shadow-period-hidden[data-v-815962b4] {\n  display: none !important;\n}\n.shadow-period[data-v-815962b4] {\n  z-index: 10;\n  border-top: 2px dashed grey;\n  border-bottom: 2px dashed grey;\n  width: 100%;\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n}\n.period[data-v-815962b4] {\n  background: #f2f3fd;\n  border-top: 1px solid #b1b4cd;\n  border-bottom: 1px solid #b1b4cd;\n  border-right: 1px solid #b1b4cd;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  width: 90%;\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  padding: 8px 8px;\n}\n.period[data-v-815962b4]:hover {\n  cursor: pointer;\n}\n.period-shadow[data-v-815962b4] {\n  border-left: 1px solid #b1b4cd;\n  border-radius: 4px;\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.15);\n}\n.period-editing[data-v-815962b4] {\n  border-left: 1px solid #b1b4cd;\n  border-radius: 4px;\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.15);\n  z-index: 50;\n}\n.period-header[data-v-815962b4] {\n  border-left: 3px solid #2a2e51;\n  padding-left: 8px;\n}\n.period-time[data-v-815962b4] {\n  font-size: 0.8rem;\n}\n.period-edit-dlg[data-v-815962b4] {\n  z-index: 100;\n  cursor: initial;\n  will-change: transform, opacity;\n  position: absolute;\n  left: 95%;\n  width: 400px;\n  background: white;\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.15);\n  border-radius: 2px;\n  display: flex;\n  flex-direction: column;\n}\n.period-edit-dlg-header[data-v-815962b4] {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n  padding: 12px;\n}\n.period-edit-dlg-header span[data-v-815962b4] {\n    font-size: 1.3rem;\n    margin-left: 16px;\n}\n.period-edit-dlg-body[data-v-815962b4] {\n  padding: 0px 12px;\n}\n.period-edit-dlg-body-section[data-v-815962b4] {\n  padding: 12px 0px;\n  display: flex;\n}\n.period-edit-dlg-body-section > *[data-v-815962b4] {\n    flex: 1;\n    margin: 0px 12px;\n}\n.period-edit-dlg-body-section input[data-v-815962b4] {\n    width: 100%;\n}\n.period-edit-dlg-body-section *[data-v-815962b4] {\n    display: block;\n}\n.period-edit-close-btn[data-v-815962b4]:hover {\n  cursor: pointer;\n}\n.period-edit-save-btn[data-v-815962b4] {\n  margin-top: 12px;\n  width: 100%;\n  border: none;\n  background: #51a95b;\n  align-self: flex-end;\n  color: #f2f3fd;\n  border-bottom-left-radius: 2px;\n  border-bottom-right-radius: 2px;\n  font-family: \"league Spartan\";\n  font-size: 1.1rem;\n  padding: 8px;\n}\n", ""]);

// exports


/***/ }),

/***/ "FQdh":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("JVj3");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("2ab1c234", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e0db976e\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./registration.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e0db976e\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./registration.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "FYvM":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("+pr7");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("2f289155", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-29e8c3c6\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./header.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-29e8c3c6\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./header.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Fn2k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profile_vue__ = __webpack_require__("YUwK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profile_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profile_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profile_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profile_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d0b1749_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_vue__ = __webpack_require__("pXi0");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("47bv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d0b1749"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profile_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d0b1749_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/profile.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3d0b1749", Component.options)
  } else {
    hotAPI.reload("data-v-3d0b1749", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "GIKM":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.dashboard-container[data-v-467a34bd] {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n.dashboard-header[data-v-467a34bd] {\n  flex-shrink: 0;\n  background: white;\n  color: #2a2e51;\n  border-bottom: 1px solid #b1b4cd;\n  border-top: 6px solid #2b8588;\n}\n.dashboard-header .profile-btn[data-v-467a34bd] {\n    color: #fb8609;\n    padding: 8px 16px;\n    border-radius: 4px;\n    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);\n    font-size: 2rem;\n}\n.dashboard-header .header-upper[data-v-467a34bd] {\n    padding: 4px 32px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n.dashboard-header .header-upper h2[data-v-467a34bd] {\n      letter-spacing: 6px;\n}\n.dashboard-header .header-lower[data-v-467a34bd] {\n    margin-top: 16px;\n    font-weight: 800;\n    font-size: 2.2rem;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n}\n.dashboard-header .header-lower > span[data-v-467a34bd] {\n      margin: 0px 24px;\n}\n.dashboard-header .header-nav[data-v-467a34bd] {\n    margin-top: 48px;\n    font-size: 1.2rem;\n    font-weight: 800;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n}\n.dashboard-header .header-nav > div[data-v-467a34bd] {\n      margin: 0px 30px;\n      padding: 0px 24px;\n}\n.dashboard-header .header-nav > div[data-v-467a34bd]:hover {\n      color: #2b8588;\n      border-bottom: 6px solid #2b8588;\n}\n.dashboard-header .header-nav .selected[data-v-467a34bd] {\n      border-bottom: 6px solid #2b8588;\n}\n.dashboard-header .header-nav .selected a[data-v-467a34bd] {\n      color: #2b8588 !important;\n}\n.dashboard-header .header-nav a[data-v-467a34bd] {\n      text-decoration: none;\n}\n.dashboard-header .header-nav a[data-v-467a34bd]:link {\n      color: #2a2e51;\n}\n.dashboard-header .header-nav a[data-v-467a34bd]:visited {\n      color: #2a2e51;\n}\n.body[data-v-467a34bd] {\n  background: #f2f3fd;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: row;\n  padding: 20px 60px;\n}\n", ""]);

// exports


/***/ }),

/***/ "HIWr":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "HQfR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "header" },
      _vm._l(_vm.headerFields, function(f) {
        return _c("div", { style: _vm.calcWidth(f) }, [
          _vm._v("\n      " + _vm._s(f.display) + "\n    ")
        ])
      })
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "body" },
      _vm._l(_vm.rows, function(r) {
        return _c(
          "div",
          {
            key: r.id,
            staticClass: "row",
            on: {
              click: function($event) {
                _vm.rowSelected(r)
              }
            }
          },
          _vm._l(_vm.headerFields, function(f) {
            return _c("div", { style: _vm.calcWidth(f) }, [
              _vm._v("\n        " + _vm._s(r[f.field]) + "\n      ")
            ])
          })
        )
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-87dc9032", esExports)
  }
}

/***/ }),

/***/ "I2vD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mask",
      on: {
        click: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.close($event)
        }
      }
    },
    [
      _c("div", { staticClass: "body" }, [
        _c("h2", [
          _vm._v(
            _vm._s(_vm.attendee.firstName) + " " + _vm._s(_vm.attendee.lastName)
          )
        ]),
        _vm._v(" "),
        _c("h4", [_vm._v("Email")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.attendee.email))]),
        _vm._v(" "),
        _c("h4", [_vm._v("Phone")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.attendee.phone))]),
        _vm._v(" "),
        _c("h4", [_vm._v("Track")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.attendee.track))]),
        _vm._v(" "),
        _c("h4", [_vm._v("Authenticated")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.attendee.authenticated))]),
        _vm._v(" "),
        _c("h4", [_vm._v("Access Codes")]),
        _vm._v(" "),
        _c(
          "ul",
          _vm._l(_vm.attendee.accessCodes, function(code) {
            return _c("li", [_vm._v(_vm._s(code.code))])
          })
        ),
        _vm._v(" "),
        _c("div", [
          _c("input", {
            staticClass: "dark",
            attrs: { type: "button", value: "Create Code" },
            on: {
              click: function($event) {
                _vm.addCode()
              }
            }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04679dd0", esExports)
  }
}

/***/ }),

/***/ "I4t6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      formEmail: "",
      formPassword: "",
      loginSuccess: null
    };
  },

  computed: {},
  methods: {
    login: function login() {
      var _this = this;

      this.$store.dispatch("users/login", {
        email: this.formEmail,
        password: this.formPassword
      }).then(function (r) {
        _this.loginSuccess = r.success;
      }).catch(function (r) {
        _this.loginSuccess = false;
      });
    }
  },
  components: {},
  mounted: function mounted() {}
};

/***/ }),

/***/ "IDEl":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("TGvM");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("20edc21c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-87dc9032\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./aGrid.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-87dc9032\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./aGrid.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "IWiR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    attendee: {
      default: null
    }
  },
  methods: {
    close: function close() {
      this.$emit('close');
    },
    addCode: function addCode() {
      this.$store.dispatch('attendees/createAccessCode', { id: this.attendee.id });
    }
  },
  computed: {}
};

/***/ }),

/***/ "IcnI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return new _vuex2.default.Store({
    strict: true,
    state: {
      loading: false,
      userSession: null
    },
    mutations: {
      loading: function loading(state, v) {
        state.loading = v;
      }
    },
    modules: {
      events: (0, _events2.default)(),
      attendees: (0, _attendees2.default)(),
      users: _users2.default
    }
  });
};

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__("NYxO");

var _vuex2 = _interopRequireDefault(_vuex);

var _events = __webpack_require__("Y5KQ");

var _events2 = _interopRequireDefault(_events);

var _users = __webpack_require__("xSZb");

var _users2 = _interopRequireDefault(_users);

var _attendees = __webpack_require__("f1aW");

var _attendees2 = _interopRequireDefault(_attendees);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

/***/ }),

/***/ "Iq/D":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.expand-button[data-v-48495f08] {\n  border-radius: 4px;\n  color: #2a2e51;\n  background: #f2f3fd;\n}\n.expand-button-header[data-v-48495f08] {\n  display: flex;\n  padding: 4px 12px;\n  justify-content: space-between;\n}\n.expand-button-body[data-v-48495f08] {\n  border-top: 1px solid #b1b4cd;\n  height: 200px;\n  padding: 4px 12px;\n}\n", ""]);

// exports


/***/ }),

/***/ "J9h5":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "JVj3":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.header[data-v-e0db976e] {\n  flex-grow: 0;\n  flex-shrink: 0;\n  height: 45px;\n  font-family: \"League Spartan\", sans-serif;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 18px 32px;\n  background: #f2f3fd;\n  color: #2a2e51;\n}\n.header > div[data-v-e0db976e] {\n    display: flex;\n    align-items: center;\n}\nh2[data-v-e0db976e] {\n  margin: 0px 18px;\n}\nh3[data-v-e0db976e] {\n  margin: 0px 12px;\n}\n", ""]);

// exports


/***/ }),

/***/ "Jmf0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "body" },
    [
      _c("div", { staticClass: "sidebar" }, [
        _c("h4", [_vm._v("Invite Codes:")]),
        _vm._v(" "),
        _c(
          "ul",
          _vm._l(_vm.codes, function(code) {
            return _c("li", { key: code.id }, [
              _c("span", [_vm._v(_vm._s(code.value))]),
              _vm._v(" "),
              _vm._m(0, true)
            ])
          })
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "detail" },
        [
          _c("div", [
            _c(
              "span",
              {
                on: {
                  click: function($event) {
                    _vm.showCreate = true
                  }
                }
              },
              [_vm._v("Create")]
            )
          ]),
          _vm._v(" "),
          _c("aGrid", {
            staticStyle: { width: "100%" },
            attrs: { rows: _vm.attendees },
            on: { rowselected: _vm.setSelected }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.showDetail
        ? _c("attendeeDetail", {
            attrs: { attendee: _vm.selected },
            on: {
              close: function($event) {
                _vm.showDetail = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showCreate
        ? _c("attendeeCreate", {
            attrs: { eventid: _vm.id },
            on: {
              close: function($event) {
                _vm.showCreate = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "fas fa-times" })])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2bc7ec38", esExports)
  }
}

/***/ }),

/***/ "K+Ie":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("sgeZ");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("d4c6de2a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-067a7d6d\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./details.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-067a7d6d\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./details.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "K31e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__("I4t6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10d9df09_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__("6Mk+");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("2qVX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10d9df09"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10d9df09_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/login.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-10d9df09", Component.options)
  } else {
    hotAPI.reload("data-v-10d9df09", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "KUeH":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("B60+");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("9fe54baa", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-63fc1178\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./home.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-63fc1178\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./home.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "KYqO":
/***/ (function(module, exports) {

module.exports = {"_from":"elliptic@^6.0.0","_id":"elliptic@6.4.0","_inBundle":false,"_integrity":"sha1-ysmvh2LIWDYYcAPI3+GT5eLq5d8=","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"elliptic@^6.0.0","name":"elliptic","escapedName":"elliptic","rawSpec":"^6.0.0","saveSpec":null,"fetchSpec":"^6.0.0"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.4.0.tgz","_shasum":"cac9af8762c85836187003c8dfe193e5e2eae5df","_spec":"elliptic@^6.0.0","_where":"/usr/src/app/node_modules/browserify-sign","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"bundleDependencies":false,"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"deprecated":false,"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.4.0"}

/***/ }),

/***/ "Kyh9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.columnGroupFunctions = undefined;

var _interactjs = __webpack_require__("u/64");

var _interactjs2 = _interopRequireDefault(_interactjs);

var _luxon = __webpack_require__("H9QG");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var columnGroupFunctions = {
  start: {
    name: "start",
    display: function display(period) {
      return period.start.toLocaleString(_luxon.DateTime.DATE_MED);
    },
    filter: function filter(period) {
      return period.start.day;
    },
    defaults: function defaults(periods) {
      return function (newPeriod) {
        newPeriod.start = newPeriod.start.set({ day: periods[0].start.day });
        newPeriod.end = newPeriod.end.set({ day: periods[0].start.day });
        return newPeriod;
      };
    }
  },
  location: {
    name: "location",
    display: function display(period) {
      return "Location: " + period.room;
    },
    filter: function filter(period) {
      return period.room;
    },
    defaults: function defaults(periods) {
      return function (newPeriod) {
        newPeriod.room = periods[0].room;
        return newPeriod;
      };
    }
  }
};
exports.columnGroupFunctions = columnGroupFunctions;
exports.default = {
  props: {
    maxHeight: {
      type: Number,
      default: function _default() {
        return 500;
      }
    },
    existingPeriods: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    columnGroups: {
      type: Object,
      default: function _default() {
        return [columnGroupFunctions];
      }
    },
    defaultOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    columnFilter: {
      type: Object
    },
    start: {
      default: function _default() {
        return _luxon.DateTime.local().startOf("day");
      }
    },
    editingPeriod: {
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      startedAdd: false,
      shadowPeriodStart: null,
      shadowPeriodEnd: null,
      shadowPeriodColumn: null,
      stepSizeSeconds: 3600 / 2,
      height: null,
      editDlg: {
        pinnedTo: null
      },
      unsavedPeriods: []
    };
  },

  watch: {
    editingPeriod: function editingPeriod(newV, oldV) {
      if (!newV && oldV) {
        this.closeEdit(this.editDlg.pinnedTo);
      }
    }
  },
  computed: {
    periods: function periods() {
      return this.existingPeriods.concat(this.unsavedPeriods);
    },
    columns: function columns() {
      var _this = this;

      /*
      [
        {
          periods: [],
          name: "string",
          defaults: function{period}() => period,
          overlaps: [],
          offsets: "Npx"
        },
        ...
      ]
      */
      var periodGroups = this.periods.reduce(function (result, p) {
        var key = _this.columnFilter.filter(p);
        result[key] = result[key] || {
          periods: [],
          id: Object.keys(result).length
        };
        result[key].periods.push(p);
        return result;
      }, {});
      var columns = [];
      for (var key in periodGroups) {
        columns.push({
          periods: periodGroups[key].periods,
          name: this.columnFilter.display(periodGroups[key].periods[0]),
          defaults: this.columnFilter.defaults(periodGroups[key].periods)
        });
      }
      columns.forEach(function (c) {
        c.overlaps = _this.calcPeriodOverlaps(c.periods);
        c.offsets = _this.calcPeriodOffsets(c.overlaps);
      });

      if (this.columnFilter && this.defaultOptions[this.columnFilter.name]) {
        this.defaultOptions[this.columnFilter.name].forEach(function (option) {
          var defaultOption = {};
          defaultOption[_this.columnFilter.name] = option;
          if (Object.keys(periodGroups).indexOf(String(_this.columnFilter.filter(defaultOption))) === -1) {
            // key is not in existing columns, so let's add an empty column
            var _defaultOption = {};
            _defaultOption[_this.columnFilter.name] = option;

            columns.push({
              periods: [],
              name: _this.columnFilter.display(_defaultOption),
              defaults: _this.columnFilter.defaults([_defaultOption])
            });
          }
        });
      }
      columns.sort(function (a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });

      return columns;
    },
    shadowPeriodStartTime: function shadowPeriodStartTime() {
      var start = 86400 * this.shadowPeriodStart / this.height;
      return this.start.plus({ seconds: start });
    },
    shadowPeriodEndTime: function shadowPeriodEndTime() {
      var duration = 86400 * this.shadowPeriodEnd / this.height;
      return this.shadowPeriodStartTime.plus({ seconds: duration });
    },
    shadowPeriodStartTimeFormatted: function shadowPeriodStartTimeFormatted() {
      return this.shadowPeriodStartTime.toLocaleString(_luxon.DateTime.TIME_SIMPLE);
    },
    shadowPeriodEndTimeFormatted: function shadowPeriodEndTimeFormatted() {
      return this.shadowPeriodEndTime.toLocaleString(_luxon.DateTime.TIME_SIMPLE);
    },
    displayTicks: function displayTicks() {
      var n = this.start;
      var result = [];
      var startDay = n.day;

      while (n.day === startDay) {
        result.push([n, n.toLocaleString(_luxon.DateTime.TIME_SIMPLE)]);
        n = n.plus({ hours: 1 });
      }
      return result;
    },
    ticks: function ticks() {
      if (this.editDlg.pinnedTo) {
        var start = this.editDlg.pinnedTo.start;
      }
      var startDay = start.day;
      var result = [];
      while (start.day === startDay) {
        result.push([start, start.toLocaleString(_luxon.DateTime.TIME_SIMPLE)]);
        start = start.plus({ seconds: this.stepSizeSeconds });
      }
      return result;
    }
  },
  methods: {
    calcPeriodOffsets: function calcPeriodOffsets(overlaps) {
      var result = {};
      for (var periodId in overlaps) {
        if (overlaps[periodId].length == 0) {
          width = 90;
        } else {
          var width = 150 / (overlaps[periodId].length + 1);
        }

        var offset = overlaps[periodId].filter(function (v) {
          return v < periodId;
        }).length * 32;
        var shadow = offset > 0;
        result[periodId] = [width, offset, shadow];
      }
      return result;
    },
    calcPeriodOverlaps: function calcPeriodOverlaps(periods) {
      var result = {};
      periods.forEach(function (p1) {
        var p1Interval = _luxon.Interval.fromDateTimes(p1.start, p1.end);
        result[p1.id] = [];

        periods.forEach(function (p2) {
          if (p2 == p1) return;
          var p2Interval = _luxon.Interval.fromDateTimes(p2.start, p2.end);
          if (p2Interval.overlaps(p1Interval)) {
            result[p1.id].push(p2.id);
          }
        });
      });
      return result;
    },
    stepsToPixels: function stepsToPixels() {
      return this.height * this.stepSizeSeconds / 86400;
    },
    periodToPixels: function periodToPixels(p) {
      var startSeconds = p.start.diff(this.start).as("seconds") % 86400;
      var start = this.height * startSeconds / 86400;
      var durationSeconds = p.end.diff(p.start).as("seconds");
      var duration = this.height * durationSeconds / 86400;
      return {
        start: start,
        height: duration
      };
    },
    formatTime: function formatTime(datetime) {
      return datetime.toLocaleString(_luxon.DateTime.TIME_SIMPLE);
    },
    formatPeriodTitle: function formatPeriodTitle(period) {
      if (!period.title) return "No Title";

      var suffix = "";
      var truncLength = 40;
      if (period.title.length > truncLength) suffix = "...";
      return period.title.substring(0, truncLength) + suffix;
    },
    addPeriod: function addPeriod(start, end) {
      var result = {
        start: start,
        end: end,
        id: this.periods.length,
        title: null,
        location: null,
        unsaved: true
      };
      this.unsavedPeriods.push(result);
      return result;
    },
    editPeriod: function editPeriod(period) {
      var _this2 = this;

      setTimeout(function () {
        _this2.editDlg.pinnedTo = period;
        _this2.$emit("update:editingPeriod", period);
      }, 0);
    },
    closeEdit: function closeEdit(period) {
      var _this3 = this;

      if (period.unsaved) {
        var i = this.unsavedPeriods.indexOf(period);
        this.unsavedPeriods.splice(i, 1);
      }
      setTimeout(function () {
        _this3.editDlg.pinnedTo = null;
      }, 0);
    },
    removePeriod: function removePeriod(period) {
      this.$emit("periodRemoved", period);
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    this.scrollOffset = document.getElementsByClassName("scheduler-scroll-container")[0].scrollTop;
    this.height = document.getElementsByClassName("schedule-container")[0].offsetHeight;
    (0, _interactjs2.default)(".schedule-column").pointerEvents({}).on("down", function (event) {
      if (!event.target.classList.contains("schedule-column")) return;
      var columnIndex = event.target.getAttribute("data-columnid");
      _this4.shadowPeriodColumn = _this4.columns[columnIndex];
      _this4.startedAdd = true;
      console.log(event);

      var scrollOffset = document.getElementsByClassName("scheduler-scroll-container")[0].scrollTop;
      var y = event.clientY - event.target.offsetTop + window.pageYOffset + scrollOffset;
      _this4.height = event.target.offsetHeight;
      _this4.shadowPeriodStart = Math.floor(y / _this4.stepsToPixels()) * _this4.stepsToPixels();
    }).on("move", function (event) {
      var target = event.target;
      while (!target.classList.contains("schedule-column")) {
        target = target.parentNode;
      }
      if (_this4.startedAdd) {
        var scrollOffset = document.getElementsByClassName("scheduler-scroll-container")[0].scrollTop;
        var y = event.clientY - target.offsetTop + window.pageYOffset + scrollOffset;
        requestAnimationFrame(function () {
          _this4.shadowPeriodEnd = Math.floor((y - _this4.shadowPeriodStart) / _this4.stepsToPixels()) * _this4.stepsToPixels();
        });
      }
    }).on("up", function () {
      if (!_this4.startedAdd) return;
      _this4.startedAdd = false;
      var start = 86400 * _this4.shadowPeriodStart / _this4.height;
      var duration = 86400 * _this4.shadowPeriodEnd / _this4.height;

      var startOffset = {
        days: Math.floor(start / 86400),
        seconds: start - 86400 * Math.floor(start / 86400)
      };
      console.log("offset", startOffset);
      console.log("duration", duration);
      var s = _this4.start.plus(startOffset);
      var e = s.plus({ seconds: duration });
      var period = _this4.addPeriod(s, e);
      period = _this4.shadowPeriodColumn.defaults(period);
      _this4.editPeriod(period);

      _this4.shadowPeriodStart = 0;
      _this4.shadowPeriodEnd = 0;
    });
  }
};

/***/ }),

/***/ "L92P":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.body[data-v-74bc6182] {\n  margin-top: 48px;\n  align-self: center;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  border: 2px solid #b1b4cd;\n  padding: 12px;\n  border-radius: 8px;\n  width: 800px;\n  height: 600px;\n}\n", ""]);

// exports


/***/ }),

/***/ "LIpS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_miniScheduler_vue__ = __webpack_require__("+TLm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_miniScheduler_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_miniScheduler_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_miniScheduler_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_miniScheduler_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d9ebe0f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_miniScheduler_vue__ = __webpack_require__("Np9O");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("O1rx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0d9ebe0f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_miniScheduler_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d9ebe0f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_miniScheduler_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/event/miniScheduler.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0d9ebe0f", Component.options)
  } else {
    hotAPI.reload("data-v-0d9ebe0f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MYe4":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("QfxJ");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("ad687a5a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5ef48958\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./app.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5ef48958\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./app.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "MzF/":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.gridline {\n  stroke: #e8e8e8;\n}\n.mini-cal-period {\n  fill: #e8e8e8;\n  stroke: silver;\n}\n", ""]);

// exports


/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _router = __webpack_require__("YaEn");

var _router2 = _interopRequireDefault(_router);

var _app = __webpack_require__("YkRm");

var _app2 = _interopRequireDefault(_app);

__webpack_require__("/8fb");

__webpack_require__("2dpn");

var _veeValidate = __webpack_require__("sUu7");

var _veeValidate2 = _interopRequireDefault(_veeValidate);

var _config = __webpack_require__("41C8");

var _config2 = _interopRequireDefault(_config);

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
_vue2.default.use(_veeValidate2.default, { classes: true });

function loadScript(url, callback) {
  // adding the script tag to the head as suggested before
  var head = document.getElementsByTagName("head")[0];
  var script = document.createElement("script");
  script.type = "text/javascript";
  script.src = url;

  // then bind the event to the callback function
  // there are several events for cross browser compatibility
  script.onreadystatechange = callback;
  script.onload = callback;

  // fire the loading
  head.appendChild(script);
}
loadScript(_config2.default.flinkLibraryUrl, function () {
  console.log("loading", _config2.default.flinkLibraryUrl);
  flink.config.baseUrl = _config2.default.apiBaseUrl;
  _app2.default.store = (0, _store2.default)();

  /* eslint-disable no-new */
  new _vue2.default({
    el: "#app",
    router: _router2.default,
    template: "<app/>",
    components: { app: _app2.default }
  });
});

_vue2.default.config.productionTip = false;

/***/ }),

/***/ "NV4f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _luxon = __webpack_require__("H9QG");

exports.default = {
  props: ["id"],
  data: function data() {
    return {
      event: {
        start: null,
        end: null,
        name: null,
        sessions: []
      }
    };
  },

  methods: {
    getEvent: function getEvent() {
      var _this = this;

      return this.$store.dispatch("events/get", { id: this.id }).then(function () {
        return _this.$store.getters["events/event"](_this.id);
      });
    }
  },
  computed: {
    currentRoute: function currentRoute() {
      if (this.$route.path.includes('home')) return 'home';
      if (this.$route.path.includes('details')) return 'details';
      if (this.$route.path.includes('sessions')) return 'sessions';
      if (this.$route.path.includes('attendees')) return 'attendees';
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    this.getEvent(this.id).then(function (event) {
      _this2.event = event;
    });
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "Np9O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mini-sched-container" }, [
    _c(
      "div",
      { staticClass: "timeline" },
      _vm._l(_vm.tickTimeStrings, function(t) {
        return _c("div", { staticClass: "tick" }, [
          _c("span", { staticClass: "spacer" }),
          _vm._v(" "),
          _c("span", { staticClass: "label" }, [_vm._v(_vm._s(t))]),
          _vm._v(" "),
          _c("span", { staticClass: "spacer" })
        ])
      })
    ),
    _vm._v(" "),
    _c("div", [
      _c(
        "div",
        { staticClass: "mini-sched-header" },
        _vm._l(_vm.dateStrings, function(d) {
          return _c("div", { key: d }, [_vm._v(_vm._s(d))])
        })
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mini-sched-body" },
        _vm._l(_vm.visibleDates, function(d) {
          return _c("div", { staticClass: "column" }, [
            _c(
              "div",
              _vm._l(_vm.visibleRooms, function(room) {
                return _c("div", { key: room.id }, [_vm._v(_vm._s(room.name))])
              })
            ),
            _vm._v(" "),
            _c(
              "div",
              _vm._l(_vm.visibleRooms, function(room) {
                return _c(
                  "div",
                  { key: room.id, staticClass: "track" },
                  _vm._l(_vm.tickTimes, function(t) {
                    return _c(
                      "div",
                      { staticClass: "tick" },
                      _vm._l(_vm.periods, function(period) {
                        return _vm.periodBelongs(period, d, room, t)
                          ? _c("div", {
                              key: period.name,
                              staticClass: "period",
                              class: [_vm.calcPeriodPosition(period, t)],
                              style: {
                                height: _vm.calcPeriodHeight(period, t) + "%"
                              }
                            })
                          : _vm._e()
                      })
                    )
                  })
                )
              })
            )
          ])
        })
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d9ebe0f", esExports)
  }
}

/***/ }),

/***/ "NrRE":
/***/ (function(module, exports) {

module.exports = {"apiBaseUrl":"http://192.168.99.100:3000/","flinkLibraryUrl":"http://192.168.99.100:3000/client.js"}

/***/ }),

/***/ "O1rx":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("BmU7");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("7132244e", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0d9ebe0f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./miniScheduler.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0d9ebe0f\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./miniScheduler.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "O9dY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__("3f40");

__webpack_require__("4qOc");

__webpack_require__("+cgv");

var _luxon = __webpack_require__("H9QG");

var _veeValidate = __webpack_require__("sUu7");

var _vueQuillEditor = __webpack_require__("G0J2");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["id"],
  data: function data() {
    return {
      event: null,
      inputFields: {
        name: "",
        start: "",
        end: "",
        details: ""
      }
    };
  },

  computed: (0, _veeValidate.mapFields)(["eventName", "eventStart", "eventEnd", "eventDescription"]),

  methods: {
    save: function save() {
      var update = {};
      if (this.eventName.dirty) {
        update.name = this.inputFields.name;
      }
      if (this.eventStart.dirty) {
        update.start = this.inputFields.start;
      }
      if (this.eventEnd.dirty) {
        update.end = this.inputFields.end;
      }
      if (this.eventDescription.dirty) {
        update.details = this.inputFields.description;
      }
      if (Object.keys(update).length === 0) return;
      this.$store.dispatch("events/update", {
        id: this.id,
        update: update
      });
    },
    getEvent: function getEvent() {
      var _this = this;

      return this.$store.dispatch("events/get", { id: this.id }).then(function () {
        return _this.$store.getters["events/event"](_this.id);
      }).then(function (event) {
        return _this.event = event;
      });
    }
  },
  watch: {
    event: {
      deep: true,
      handler: function handler(v) {
        this.inputFields.name = v.name;
        this.inputFields.start = v.start;
        this.inputFields.end = v.end;
        this.inputFields.details = v.details;
      }
    }
  },
  beforeMount: function beforeMount() {
    this.getEvent();
  },

  components: {
    quillEditor: _vueQuillEditor.quillEditor
  }
};

/***/ }),

/***/ "PSx8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var jwt = __webpack_require__("abWm");

function get() {
  var cookieStr = getCookie("loginsession");
  if (cookieStr) {
    return jwt.decode(cookieStr);
  }
  return null;
}
function getCookie(name) {
  var v = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
  return v ? v[2] : null;
}

var session = { contents: get() };
window.setInterval(function () {
  session.contents = get();
}, 1000);

exports.default = session;

/***/ }),

/***/ "PdHH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "scheduler-body" }, [
    _c("div", [
      _c("label", [_vm._v("Group By:")]),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.schedulerOptions.columnFilter,
              expression: "schedulerOptions.columnFilter"
            }
          ],
          on: {
            change: function($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function(o) {
                  return o.selected
                })
                .map(function(o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.$set(
                _vm.schedulerOptions,
                "columnFilter",
                $event.target.multiple ? $$selectedVal : $$selectedVal[0]
              )
            }
          }
        },
        _vm._l(_vm.schedulerOptions.columnGroupFunctions, function(f) {
          return _c("option", { domProps: { value: f } }, [
            _vm._v(_vm._s(f.name))
          ])
        })
      ),
      _vm._v(" "),
      _c("h3", [_vm._v("Rooms")]),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm._l(_vm.rooms, function(room) {
            return _c(
              "expandButton",
              {
                key: room.id,
                staticClass: "room-edit-field",
                attrs: { expanded: _vm.expandedRoom === room }
              },
              [
                _c("template", { slot: "header" }, [
                  _c("div", [_vm._v(_vm._s(room.name))]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      on: {
                        click: function($event) {
                          _vm.toggleRoomExpanded(room)
                        }
                      }
                    },
                    [_c("i", { staticClass: "far fa-edit" })]
                  )
                ]),
                _vm._v(" "),
                _c("template", { slot: "body" }, [
                  _c("label", [_vm._v("Name:")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.roomEditFields.name,
                        expression: "roomEditFields.name"
                      }
                    ],
                    staticClass: "dark",
                    domProps: { value: _vm.roomEditFields.name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.roomEditFields,
                          "name",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", [_vm._v("ID:")]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(room.id))]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          _vm.editRoom(room)
                        }
                      }
                    },
                    [_vm._v("Save")]
                  )
                ])
              ],
              2
            )
          }),
          _vm._v(" "),
          _c(
            "expandButton",
            {
              staticClass: "room-edit-field",
              attrs: { expanded: _vm.addRoomExpanded }
            },
            [
              _c("template", { slot: "header" }, [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        _vm.addRoomExpanded = !_vm.addRoomExpanded
                      }
                    }
                  },
                  [_vm._v("Add a New Room")]
                )
              ]),
              _vm._v(" "),
              _c("template", { slot: "body" }, [
                _c("label", [_vm._v("Name:")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newRoom.name,
                      expression: "newRoom.name"
                    }
                  ],
                  staticClass: "dark",
                  domProps: { value: _vm.newRoom.name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.newRoom, "name", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    on: {
                      click: function($event) {
                        _vm.createNewRoom(_vm.newRoom)
                      }
                    }
                  },
                  [_vm._v("Save")]
                )
              ])
            ],
            2
          )
        ],
        2
      ),
      _vm._v(" "),
      _c("h3", [_vm._v("Tracks")])
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("periodEditor", {
          attrs: { rooms: _vm.rooms, editingPeriod: _vm.editingPeriod },
          on: {
            periodAdded: _vm.periodAdded,
            periodUpdated: _vm.periodUpdated,
            periodRemoved: _vm.periodRemoved,
            "update:editingPeriod": function($event) {
              _vm.editingPeriod = $event
            }
          }
        }),
        _vm._v(" "),
        _c("scheduler", {
          attrs: {
            columnGroups: _vm.schedulerOptions.columnGroupFunctions,
            columnFilter: _vm.schedulerOptions.columnFilter,
            defaultOptions: _vm.schedulerOptions.defaultOptions,
            start: _vm.schedulerOptions.start,
            existingPeriods: _vm.periods,
            editingPeriod: _vm.editingPeriod
          },
          on: {
            "update:editingPeriod": function($event) {
              _vm.editingPeriod = $event
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8888eb08", esExports)
  }
}

/***/ }),

/***/ "QDfD":
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ "QfxJ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\nbody {\n  background: #2a2e51;\n  color: #f2f3fd;\n}\n#app {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n", ""]);

// exports


/***/ }),

/***/ "QqZo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_periodEditor_vue__ = __webpack_require__("7R9x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_periodEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_periodEditor_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_periodEditor_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_periodEditor_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75cf371a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_periodEditor_vue__ = __webpack_require__("kfxy");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("gDlm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75cf371a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_periodEditor_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75cf371a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_periodEditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/event/periodEditor.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-75cf371a", Component.options)
  } else {
    hotAPI.reload("data-v-75cf371a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "S7gw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      eventName: "",
      eventRange: null,
      attrs: [{
        key: "today",
        dates: new Date(),
        highlight: {
          backgroundColor: "#ff8080"
        },
        contentStyle: {
          color: "#fafafa"
        },
        popover: null
      }]
    };
  },

  methods: {
    save: function save() {
      var _this = this;

      this.$store.dispatch("events/create", {
        name: this.eventName,
        start: this.eventRange.start,
        end: this.eventRange.end
      }).then(function (newEvent) {
        _this.$router.push("/event/" + newEvent.id);
      });
    }
  }
};

/***/ }),

/***/ "TGvM":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.header[data-v-87dc9032] {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  text-align: center;\n  padding: 12px 24px;\n  border-bottom: 2px solid #b1b4cd;\n}\n.header > div[data-v-87dc9032] {\n    flex: 1;\n}\n.row[data-v-87dc9032] {\n  display: flex;\n  font-weight: 400;\n  flex-direction: row;\n  justify-content: space-between;\n  text-align: center;\n  padding: 6px 24px;\n  border-bottom: 1px dotted #b1b4cd;\n}\n.row > div[data-v-87dc9032] {\n    flex: 1;\n}\n.row[data-v-87dc9032]:hover {\n  background: #f2f2f2;\n  cursor: pointer;\n}\n", ""]);

// exports


/***/ }),

/***/ "UtL+":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.body[data-v-2bc7ec38] {\n  color: #2a2e51;\n  padding: 0px;\n  background: white;\n  border-radius: 4px;\n  border: 1px solid #b1b4cd;\n}\n.sidebar[data-v-2bc7ec38] {\n  width: 250px;\n  border-right: 1px solid #b1b4cd;\n  flex-shrink: 0;\n}\n.detail[data-v-2bc7ec38] {\n  flex-grow: 1;\n}\n", ""]);

// exports


/***/ }),

/***/ "VUAA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "scheduler-container" }, [
    _c(
      "div",
      { staticClass: "schedule-header" },
      _vm._l(_vm.columns, function(c) {
        return _c("div", [_vm._v(_vm._s(c.name))])
      })
    ),
    _vm._v(" "),
    _c("div", { staticClass: "scheduler-scroll-container" }, [
      _c(
        "div",
        { staticClass: "schedule-container" },
        [
          _c(
            "div",
            { staticClass: "schedule-timeline" },
            _vm._l(_vm.displayTicks, function(t) {
              return _c("div", { key: t[1] }, [_vm._v(_vm._s(t[1]))])
            })
          ),
          _vm._v(" "),
          _vm._l(_vm.columns, function(c, i) {
            return _c(
              "div",
              { staticClass: "schedule-column", attrs: { "data-columnid": i } },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.shadowPeriodColumn === c,
                        expression: "shadowPeriodColumn === c"
                      }
                    ],
                    staticClass: "shadow-period",
                    class: { "shadow-period-hidden": !_vm.startedAdd },
                    style: {
                      top: _vm.shadowPeriodStart + "px",
                      height: _vm.shadowPeriodEnd + "px"
                    }
                  },
                  [
                    _c("div", { staticClass: "shadow-period-coords" }, [
                      _vm._v(
                        "\n          start:" +
                          _vm._s(_vm.shadowPeriodStartTimeFormatted) +
                          "\n          end:" +
                          _vm._s(_vm.shadowPeriodEndTimeFormatted) +
                          "\n        "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm._l(c.periods, function(period) {
                  return _c(
                    "div",
                    {
                      key: period.id,
                      staticClass: "period",
                      class: {
                        "period-shadow": c.offsets[period.id][2],
                        "period-editing": _vm.editDlg.pinnedTo === period
                      },
                      style: {
                        top: _vm.periodToPixels(period).start + "px",
                        height: _vm.periodToPixels(period).height + "px",
                        width: c.offsets[period.id][0] + "%",
                        "margin-left": c.offsets[period.id][1] + "px"
                      },
                      on: {
                        click: function($event) {
                          if ($event.target !== $event.currentTarget) {
                            return null
                          }
                          _vm.editPeriod(period)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "period-header" }, [
                        _c("div", [
                          _vm._v(_vm._s(_vm.formatPeriodTitle(period)))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "period-time" }, [
                          _vm._v(
                            _vm._s(_vm.formatTime(period.start)) +
                              " - " +
                              _vm._s(_vm.formatTime(period.end))
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "period-time" }, [
                          _vm._v(_vm._s(period.location))
                        ])
                      ])
                    ]
                  )
                })
              ],
              2
            )
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-815962b4", esExports)
  }
}

/***/ }),

/***/ "WVLx":
/***/ (function(module, exports) {

module.exports = {"apiBaseUrl":"localhost:3000/"}

/***/ }),

/***/ "XKi2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    rows: {
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    rowSelected: function rowSelected(row) {
      this.$emit("rowselected", row);
    },
    calcWidth: function calcWidth(field) {
      var result = {};
      if (field.maxWidth) {
        result["max-width"] = field.maxWidth + "px";
      }
      if (field.width) {
        result["width"] = field.width + "px";
      }
      return result;
    }
  },
  computed: {
    headerFields: function headerFields() {
      return {
        id: {
          sortable: false,
          display: "ID",
          field: "id",
          maxWidth: 100
        },
        firstName: {
          sortable: false,
          display: "First Name",
          field: "firstName"
        },
        lastName: { sortable: false, display: "Last Name", field: "lastName" },
        email: { sortable: false, display: "Email", field: "lastName" }
      };
    }
  }
};

/***/ }),

/***/ "XiBC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.session.contents
        ? _c("div", [
            _vm._v(
              "\n    You're already logged in!\n    Click here to continue\n    Click here to log out\n  "
            )
          ])
        : [
            _c(_vm.component, { tag: "component" }),
            _vm._v(" "),
            _vm.component === "login"
              ? _c(
                  "h3",
                  [
                    _c("router-link", { attrs: { to: "/signup" } }, [
                      _vm._v("Or Signup")
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.component === "signup"
              ? _c(
                  "h3",
                  [
                    _c("router-link", { attrs: { to: "/login" } }, [
                      _vm._v("Or Login")
                    ])
                  ],
                  1
                )
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e0db976e", esExports)
  }
}

/***/ }),

/***/ "Xv87":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["eventid"],
  data: function data() {
    return {
      firstName: "",
      phone: "",
      email: ""
    };
  },

  methods: {
    close: function close() {
      this.$emit("close");
    },
    submit: function submit() {
      var _this = this;

      this.$store.dispatch("attendees/create", {
        firstName: this.firstName,
        phone: this.phone,
        email: this.email,
        eventId: this.eventid
      }).then(function () {
        _this.close();
      });
    }
  },
  computed: {}
};

/***/ }),

/***/ "Y5KQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return {
    namespaced: true,
    state: {
      events: {}
    },
    getters: {
      events: function events(state) {
        return state.events;
      },
      event: function event(state) {
        return function (id) {
          return state.events[id];
        };
      }
    },
    mutations: {
      setEventById: function setEventById(state, _ref2) {
        var id = _ref2.id,
            body = _ref2.body;

        setFromJson(state.events, body);
      }
    },
    actions: createActions()
  };
};

var _luxon = __webpack_require__("H9QG");

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createActions() {
  var actions = {};
  Object.keys(flink.event).forEach(function (f) {
    actions[f] = function (_ref, args) {
      var commit = _ref.commit;

      commit("loading", true, { root: true });
      return flink.event[f](args).then(function (result) {
        if (Array.isArray(result)) {
          result.forEach(function (e) {
            commit("setEventById", { id: e.id, body: e });
          });
        } else {
          commit("setEventById", { id: result.id, body: result });
        }
        return result;
      }).then(function (result) {
        commit("loading", false, { root: true });
        return result;
      }).catch(function (err) {
        commit("loading", false, { root: true });
        throw err;
      });
    };
  });
  return actions;
}

function setFromJson(events, body) {
  var id = body.id;
  for (var key in body.sessions) {
    var session = body.sessions[key];
    session.start = _luxon.DateTime.fromISO(session.start, {
      setZone: true
    });
    session.end = _luxon.DateTime.fromISO(session.end, { setZone: true });
  }

  events[id] = events[id] || {};
  events[id].name = body.name;
  events[id].id = body.id;
  events[id].details = body.details;
  events[id].start = _luxon.DateTime.fromISO(body.start, { setZone: true }).startOf("day");
  events[id].end = _luxon.DateTime.fromISO(body.end, { setZone: true }).startOf("day");
  events[id].sessions = body.sessions;
  events[id].rooms = body.rooms;
}

/***/ }),

/***/ "YUwK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      user: {
        emails: [],
        organizations: [],
        user: {
          id: null,
          firstName: null,
          lastName: null
        }
      },
      inviteCode: "",
      newOrgName: ""
    };
  },
  methods: {
    joinOrganization: function joinOrganization(code) {
      flink.organization.addUser({ inviteCode: code, userId: this.user.user.id }).then(this.getUser);
    },
    createInvite: function createInvite(id) {
      flink.organization.createInvite({ orgId: id, creatorId: this.user.user.id }).then(this.getUser);
    },
    deleteOrganization: function deleteOrganization(id) {
      flink.organization.del({ orgId: id }).then(this.getUser);
    },
    createOrganization: function createOrganization(name) {
      flink.organization.create({ name: name, userIds: [this.user.user.id] }).then(this.getUser);
    },
    getUser: function getUser() {
      var _this = this;

      flink.user.get({ userId: null }).then(function (user) {
        _this.user = user;
      });
    }
  },
  mounted: function mounted() {
    this.getUser();
  },
  components: {}
};

/***/ }),

/***/ "YaEn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueResource = __webpack_require__("8+8L");

var _vueResource2 = _interopRequireDefault(_vueResource);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _profile = __webpack_require__("Fn2k");

var _profile2 = _interopRequireDefault(_profile);

var _index = __webpack_require__("tLaR");

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__("/TLO");

var _index4 = _interopRequireDefault(_index3);

var _registration = __webpack_require__("xEgl");

var _registration2 = _interopRequireDefault(_registration);

var _eventCreationPrompt = __webpack_require__("+Ai8");

var _eventCreationPrompt2 = _interopRequireDefault(_eventCreationPrompt);

var _details = __webpack_require__("14ux");

var _details2 = _interopRequireDefault(_details);

var _attendees = __webpack_require__("ClqJ");

var _attendees2 = _interopRequireDefault(_attendees);

var _schedule = __webpack_require__("CNCi");

var _schedule2 = _interopRequireDefault(_schedule);

var _home = __webpack_require__("nDGq");

var _home2 = _interopRequireDefault(_home);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueResource2.default);
_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
  routes: [{
    path: "/",
    redirect: "/dashboard"
  }, {
    path: "/eventcreate",
    component: _eventCreationPrompt2.default,
    meta: { showLoginPrompt: true }
  }, {
    path: "/dashboard",
    component: _index4.default,
    meta: { showLoginPrompt: true }
  }, {
    path: "/signup",
    component: _registration2.default,
    props: { component: "signup" },
    meta: { showLoginPrompt: false }
  }, {
    path: "/login",
    component: _registration2.default,
    props: { component: "login" },
    meta: { showLoginPrompt: false }
  }, {
    path: "/profile",
    component: _profile2.default,
    meta: { showLoginPrompt: true }
  }, {
    path: "/event/:id",
    redirect: "/event/:id/home"
  }, {
    path: "/event/:id",
    component: _index2.default,
    props: true,
    meta: { showLoginPrompt: true },
    children: [{
      path: "home",
      component: _home2.default,
      props: true
    }, {
      path: "details",
      component: _details2.default,
      props: true
    }, {
      path: "sessions",
      component: _schedule2.default,
      props: true
    }, {
      path: "attendees",
      component: _attendees2.default,
      props: true
    }]
  }]
});

/***/ }),

/***/ "YkRm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__ = __webpack_require__("39ur");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ef48958_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__("t0kG");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("MYe4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ef48958_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5ef48958", Component.options)
  } else {
    hotAPI.reload("data-v-5ef48958", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "dMSp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _scheduler = __webpack_require__("D46J");

var _scheduler2 = _interopRequireDefault(_scheduler);

var _periodEditor = __webpack_require__("QqZo");

var _periodEditor2 = _interopRequireDefault(_periodEditor);

var _expandButton = __webpack_require__("EiCj");

var _expandButton2 = _interopRequireDefault(_expandButton);

var _luxon = __webpack_require__("H9QG");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ["id"],
  data: function data() {
    return {
      event: null,
      schedulerOptions: {
        columnGroupFunctions: _scheduler.columnGroupFunctions,
        defaultOptions: {
          location: [],
          start: []
        },
        columnFilter: _scheduler.columnGroupFunctions.start,
        start: _luxon.DateTime.local().startOf("day")
      },
      editingPeriod: null,
      expandedRoom: null,
      addRoomExpanded: false,
      roomEditFields: {
        name: ""
      },
      newRoom: {
        name: ""
      }
    };
  },

  methods: {
    toggleRoomExpanded: function toggleRoomExpanded(room) {
      if (this.expandedRoom === room) {
        this.expandedRoom = null;
      } else {
        this.expandedRoom = room;
        this.roomEditFields.name = room.name;
      }
    },

    getEvent: function getEvent() {
      var _this = this;

      return this.$store.dispatch("events/get", { id: this.id }).then(function () {
        return _this.$store.getters["events/event"](_this.id);
      });
    },
    periodAdded: function periodAdded(period) {
      var _this2 = this;

      this.$store.dispatch("events/addSession", {
        eventId: this.id,
        session: period
      }).then(function () {
        _this2.editingPeriod = null;
      });
    },
    periodRemoved: function periodRemoved(period) {
      var _this3 = this;

      this.$store.dispatch("events/deleteSession", {
        eventId: this.id,
        sessionId: period.id
      }).then(function () {
        _this3.editingPeriod = null;
      });
    },
    periodUpdated: function periodUpdated(update) {
      var _this4 = this;

      this.$store.dispatch("events/updateSession", {
        sessionId: this.editingPeriod.id,
        update: update
      }).then(function () {
        _this4.editingPeriod = null;
      });
    },
    createNewRoom: function createNewRoom(room) {
      this.$store.dispatch("events/addRoom", { eventId: this.event.id, room: room });
    },
    editRoom: function editRoom(room) {
      this.$store.dispatch("events/editRoom", {
        roomId: room.id,
        update: this.roomEditFields
      });
    },
    periodEditing: function periodEditing(period) {
      this.editingPeriod = period;
    },
    closeEdit: function closeEdit() {
      this.editingPeriod = null;
    }
  },
  computed: {
    rooms: function rooms() {
      var result = [];
      if (this.event) {
        for (var id in this.event.rooms) {
          result.push(this.event.rooms[id]);
        }
      }
      return result;
    },

    periods: function periods() {
      var r = [];
      if (!this.event) return r;
      for (var i in this.event.sessions) {
        r.push(this.event.sessions[i]);
      }
      return r;
    }
  },
  beforeMount: function beforeMount() {
    var _this5 = this;

    this.getEvent().then(function (event) {
      _this5.event = event;
      var start = event.start.startOf("day");
      var end = event.end.startOf("day");

      _this5.schedulerOptions.start = start;
      _this5.schedulerOptions.periods = _this5.periods;
      _this5.schedulerOptions.defaultOptions.location.push("unset");

      var n = start;
      while (n <= end) {
        _this5.schedulerOptions.defaultOptions.start.push(n);
        n = n.plus({ days: 1 });
      }
    });
  },
  components: {
    scheduler: _scheduler2.default,
    expandButton: _expandButton2.default,
    periodEditor: _periodEditor2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "dTeq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "detail-body" }, [
    _c("div", { staticClass: "main-section" }, [
      _c("div", [
        _c("label", [_vm._v("Event Name")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.inputFields.name,
              expression: "inputFields.name"
            },
            { name: "validate", rawName: "v-validate" }
          ],
          staticClass: "dark",
          attrs: { type: "text", placeholder: "Event Name", name: "eventName" },
          domProps: { value: _vm.inputFields.name },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.inputFields, "name", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [_vm._v("Start Date")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.inputFields.start,
              expression: "inputFields.start"
            },
            { name: "validate", rawName: "v-validate" }
          ],
          staticClass: "dark",
          attrs: {
            type: "text",
            placeholder: "Start Date",
            name: "eventStart"
          },
          domProps: { value: _vm.inputFields.start },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.inputFields, "start", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [_vm._v("End Date")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.inputFields.end,
              expression: "inputFields.end"
            },
            { name: "validate", rawName: "v-validate" }
          ],
          staticClass: "dark",
          attrs: { type: "text", placeholder: "End Date", name: "eventEnd" },
          domProps: { value: _vm.inputFields.end },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.inputFields, "end", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "details-section" }, [
        _c("label", [_vm._v("Details")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "editor-body" },
          [
            _c("quill-editor", {
              directives: [{ name: "validate", rawName: "v-validate" }],
              attrs: { name: "eventDescription" },
              model: {
                value: _vm.inputFields.details,
                callback: function($$v) {
                  _vm.$set(_vm.inputFields, "details", $$v)
                },
                expression: "inputFields.details"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "right-section" }, [
      _c("label", [_vm._v("Brand")]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("input", {
        staticClass: "dark",
        attrs: { type: "button", value: "Save" },
        on: {
          click: function($event) {
            _vm.save()
          }
        }
      })
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "brand-container" }, [
      _c("div", [
        _c("label", [_vm._v("Primary Color")]),
        _vm._v(" "),
        _c("input", { attrs: { type: "text" } })
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [_vm._v("Secondary Color")]),
        _vm._v(" "),
        _c("input", { attrs: { type: "text" } })
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [_vm._v("Font")]),
        _vm._v(" "),
        _c("input", { attrs: { type: "text" } })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "brand-preview" }, [
        _c("label", { staticStyle: { display: "block" } }, [_vm._v("Preview")]),
        _vm._v(" "),
        _c("div", { staticClass: "brand-preview-body" })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-067a7d6d", esExports)
  }
}

/***/ }),

/***/ "dWup":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _luxon = __webpack_require__("H9QG");

var _notificationList = __webpack_require__("x7I3");

var _notificationList2 = _interopRequireDefault(_notificationList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//

function objToArray(obj) {
  var result = [];
  for (var key in obj) {
    result.push(obj[key]);
  }
  return result;
}
exports.default = {
  props: ["id"],
  data: function data() {
    return {
      now: _luxon.DateTime.local().toJSDate(),
      event: {
        start: null,
        end: null,
        name: null,
        sessions: []
      }
    };
  },

  methods: {
    getEvent: function getEvent() {
      var _this = this;

      return this.$store.dispatch("events/get", { id: this.id }).then(function () {
        return _this.$store.getters["events/event"](_this.id);
      });
    },
    drawMiniScheduler: function drawMiniScheduler() {
      var start = this.event.start;
      var end = this.event.end;
      var rooms = objToArray(this.event.rooms) || [];
      rooms.unshift({
        name: "unset",
        id: null
      });
      var sessions = [];
      for (var id in this.event.sessions) {
        sessions.push(this.event.sessions[id]);
      }
      var now = this.now;
      var roomCount = rooms.length;
      var columnWidth = 100;
      var pixelsPerDay = 1500;
      var height = end.diff(start, "days").days * pixelsPerDay;
      var y = d3.scaleTime().domain([start, end]).range([0, height]);

      var roomScale = d3.scaleBand().domain(rooms.map(function (r) {
        return r.name;
      })).range([0, roomCount * columnWidth]);

      var axisLeft = d3.axisLeft(y).ticks(d3.timeMinute.every(30));
      var axisTop = d3.axisTop(roomScale);

      var gridlines = d3.axisLeft(y).ticks(d3.timeMinute.every(30)).tickFormat("").tickSize(-1 * height);

      // chart container
      var chart = d3.select("#test").append("svg:svg").attr("height", function () {
        return height;
      }).attr("width", function () {
        return roomCount * columnWidth + 51;
      });

      // top axis
      chart.append("g").attr("transform", "translate(50,50)").call(axisTop);

      // left axis
      chart.append("g").attr("transform", "translate(50,50)").call(axisLeft);

      // horizontal gridlines
      chart.append("g").attr("transform", "translate(50,50)").attr("class", "gridline").call(gridlines).selectAll("line").attr("stroke", "");

      // session boxes
      chart.append("g").attr("transform", "translate(51,51)").selectAll("rect").data(sessions).enter().append("svg:rect").attr("class", "mini-cal-period").attr("x", function (v) {
        return rooms.indexOf(rooms.filter(function (r) {
          return r.id == v.room;
        })[0]) * columnWidth;
      }).attr("y", function (v) {
        return y(v.start);
      }).attr("width", 100).attr("height", function (v) {
        return y(v.end) - y(v.start);
      });

      // current time line
      chart.append("svg:rect").attr("y", function (v) {
        return y(now);
      }).attr("transform", "translate(45,50)").attr("width", roomCount * columnWidth + 5).attr("height", 1).attr("fill", "red");

      // vertical gridlines
      chart.append("g").attr("transform", "translate(50,50)").attr("class", "gridline").selectAll("line").data(rooms).enter().append("svg:line").attr("x1", function (r, i) {
        return (i + 1) * columnWidth;
      }).attr("x2", function (r, i) {
        return (i + 1) * columnWidth;
      }).attr("y1", function (v) {
        return y(start.toJSDate());
      }).attr("y2", function (v) {
        return y(end.toJSDate());
      });
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    setInterval(function () {
      _this2.now = _luxon.DateTime.local().toJSDate();
    }, 60 * 1000);
  },
  components: {
    notificationList: _notificationList2.default
  },
  mounted: function mounted() {
    var _this3 = this;

    this.getEvent(this.id).then(function (event) {
      _this3.event = event;
      _this3.drawMiniScheduler();
    });
  }
};

/***/ }),

/***/ "ejIc":
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ "f1aW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return {
    namespaced: true,
    state: {
      attendees: {}
    },
    getters: {
      attendees: function attendees(state) {
        return state.attendees;
      },
      attendee: function attendee(state) {
        return function (id) {
          return state.attendees[id];
        };
      }
    },
    mutations: {
      setById: function setById(state, _ref2) {
        var id = _ref2.id,
            body = _ref2.body;

        setFromJson(state.attendees, body);
      }
    },
    actions: createActions()
  };
};

var _luxon = __webpack_require__("H9QG");

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createActions() {
  var actions = {};
  Object.keys(flink.attendee).forEach(function (f) {
    actions[f] = function (_ref, args) {
      var commit = _ref.commit;

      commit("loading", true, { root: true });
      return flink.attendee[f](args).then(function (result) {
        if (Array.isArray(result)) {
          result.forEach(function (e) {
            commit("setById", { id: e.id, body: e });
          });
        } else {
          commit("setById", { id: result.id, body: result });
        }
        return result;
      }).then(function (result) {
        commit("loading", false, { root: true });
        return result;
      }).catch(function (err) {
        commit("loading", false, { root: true });
        throw err;
      });
    };
  });
  return actions;
}

function setFromJson(records, body) {
  var id = body.id;
  var newRecord = records[id] || {};
  newRecord = records[id] || {};
  newRecord.id = body.id;
  newRecord.firstName = body.firstName;
  newRecord.middleName = body.middleName;
  newRecord.email = body.email;
  newRecord.phone = body.phone;
  newRecord.event = body.event;
  newRecord.accessCodes = body.accessCodes;

  _vue2.default.set(records, id, newRecord);
}

/***/ }),

/***/ "fEDi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _luxon = __webpack_require__("H9QG");

var _notificationList = __webpack_require__("x7I3");

var _notificationList2 = _interopRequireDefault(_notificationList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["id"],
  data: function data() {
    return {
      events: []
    };
  },

  methods: {
    getEvents: function getEvents() {
      return this.$store.dispatch("events/list", {});
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.getEvents().then(function (events) {
      _this.events = _this.$store.getters["events/events"];
    });
  },
  components: {
    notificationList: _notificationList2.default
  }
};

/***/ }),

/***/ "fx46":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("wL8c");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("366f9543", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-52077837\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-52077837\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "gDlm":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("kqV2");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("f8bb907a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-75cf371a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./periodEditor.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-75cf371a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./periodEditor.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "i5LY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "body" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "heads-up-list" },
      [_c("h3", [_vm._v("Heads Up:")]), _vm._v(" "), _c("notificationList")],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mini-schedule" }, [
      _c("div", { attrs: { id: "test" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63fc1178", esExports)
  }
}

/***/ }),

/***/ "k2mo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {};
  }
};

/***/ }),

/***/ "kfxy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.editingPeriod
    ? _c(
        "div",
        {
          staticClass: "period-editor-container",
          on: {
            click: function($event) {
              if ($event.target !== $event.currentTarget) {
                return null
              }
              return _vm.closeEditor($event)
            }
          }
        },
        [
          _c("div", { staticClass: "period-editor-body" }, [
            _c("div", { staticClass: "period-editor-header" }, [
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.input.title,
                      expression: "input.title"
                    }
                  ],
                  staticClass: "dark",
                  staticStyle: { "font-size": "1.3rem" },
                  attrs: { type: "text", placeholder: "Session Name" },
                  domProps: { value: _vm.input.title },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.input, "title", $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticStyle: { margin: "4px 8px" } }, [
                  _vm._v("For Event SDFDFNDF")
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.editingPeriod.unsaved,
                        expression: "!editingPeriod.unsaved"
                      }
                    ],
                    on: {
                      click: function($event) {
                        _vm.removePeriod()
                      }
                    }
                  },
                  [_c("i", { staticClass: "fas fa-trash-alt" })]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        _vm.closeEditor()
                      }
                    }
                  },
                  [_c("i", { staticClass: "fas fa-times" })]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "period-editor-content" }, [
              _c("div", [
                _c("label", [_vm._v("Start")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.input.start,
                        expression: "input.start"
                      }
                    ],
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.input,
                          "start",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.ticks, function(o) {
                    return _c(
                      "option",
                      { key: o[1], domProps: { value: o[0] } },
                      [_vm._v(_vm._s(o[1]))]
                    )
                  })
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c("label", [_vm._v("End")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.input.end,
                        expression: "input.end"
                      }
                    ],
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.input,
                          "end",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.ticks, function(o) {
                    return _c(
                      "option",
                      { key: o[1], domProps: { value: o[0] } },
                      [_vm._v(_vm._s(o[1]))]
                    )
                  })
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c("label", [_vm._v("Room")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.input.room,
                        expression: "input.room"
                      }
                    ],
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.input,
                          "room",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.roomOptions, function(room) {
                    return _c("option", { domProps: { value: room.id } }, [
                      _vm._v(_vm._s(room.name))
                    ])
                  })
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c("label", [_vm._v("Recurrences")]),
                _vm._v(" "),
                _c("div", { staticClass: "group-box" }, [
                  _c(
                    "div",
                    [
                      _vm._l(_vm.recurrences, function(recurrence) {
                        return _c("div", { staticClass: "recur-input" }, [
                          _c("div", [
                            _c("div", { staticClass: "recur-label" }, [
                              _vm._v("Start")
                            ]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: recurrence.start,
                                    expression: "recurrence.start"
                                  }
                                ],
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      recurrence,
                                      "start",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  }
                                }
                              },
                              _vm._l(_vm.ticks, function(o) {
                                return _c(
                                  "option",
                                  { key: o[1], domProps: { value: o[0] } },
                                  [_vm._v(_vm._s(o[1]))]
                                )
                              })
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("div", { staticClass: "recur-label" }, [
                              _vm._v("Room")
                            ]),
                            _vm._v(" "),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: recurrence.room,
                                    expression: "recurrence.room"
                                  }
                                ],
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      recurrence,
                                      "room",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  }
                                }
                              },
                              _vm._l(_vm.roomOptions, function(room) {
                                return _c(
                                  "option",
                                  { domProps: { value: room.id } },
                                  [_vm._v(_vm._s(room.name))]
                                )
                              })
                            )
                          ]),
                          _vm._v(" "),
                          _vm._m(0, true)
                        ])
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "new-recur-input",
                          on: {
                            click: function($event) {
                              _vm.addRecurrence()
                            }
                          }
                        },
                        [
                          _c("div", [_vm._v("Add Recurrence")]),
                          _vm._v(" "),
                          _vm._m(1)
                        ]
                      )
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "recur-preview" })
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "period-editor-footer" }, [
              _c(
                "button",
                {
                  staticClass: "period-edit-save-btn",
                  on: {
                    click: function($event) {
                      _vm.save()
                    }
                  }
                },
                [_vm._v("Save")]
              )
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("i", { staticClass: "fas fa-plus" })])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("i", { staticClass: "fas fa-plus" })])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75cf371a", esExports)
  }
}

/***/ }),

/***/ "kg7u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _luxon = __webpack_require__("H9QG");

var _aGrid = __webpack_require__("8ISW");

var _aGrid2 = _interopRequireDefault(_aGrid);

var _attendeeDetail = __webpack_require__("9up4");

var _attendeeDetail2 = _interopRequireDefault(_attendeeDetail);

var _attendeeCreate = __webpack_require__("5xgh");

var _attendeeCreate2 = _interopRequireDefault(_attendeeCreate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function objToArray(obj) {
  var result = [];
  for (var key in obj) {
    result.push(obj[key]);
  }
  return result;
}
exports.default = {
  props: ["id"],
  data: function data() {
    return {
      attendees: [],
      selected: null,
      showDetail: false,
      showCreate: false,
      codes: {
        1: { id: 1, value: "ABCDEFG" }
      }
    };
  },

  methods: {
    setSelected: function setSelected(row) {
      this.selected = row;
      this.showDetail = true;
    },

    get: function get() {
      var _this = this;

      return this.$store.dispatch("attendees/getForEvent", { eventId: this.id }).then(function () {
        return _this.$store.getters["attendees/attendees"];
      });
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    this.get().then(function (results) {
      _this2.attendees = results;
    });
  },
  components: {
    aGrid: _aGrid2.default,
    attendeeDetail: _attendeeDetail2.default,
    attendeeCreate: _attendeeCreate2.default
  },
  mounted: function mounted() {}
};

/***/ }),

/***/ "kqV2":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.period-editor-container[data-v-75cf371a] {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 100;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: rgba(26, 28, 44, 0.7);\n  color: #2a2e51;\n}\n.period-editor-body[data-v-75cf371a] {\n  width: 70%;\n  height: 85%;\n  background: #f2f3fd;\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  display: flex;\n  flex-direction: column;\n}\n.period-editor-header[data-v-75cf371a] {\n  border-bottom: 1px solid #b1b4cd;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  padding: 18px 16px 12px 16px;\n}\n.period-editor-header > div[data-v-75cf371a]:last-child {\n    align-self: baseline;\n    display: flex;\n    justify-content: flex-end;\n    flex-grow: 1;\n    font-size: 1.6rem;\n}\n.period-editor-header > div:last-child > span[data-v-75cf371a] {\n      padding: 0px 8px;\n}\n.period-editor-content[data-v-75cf371a] {\n  flex-grow: 1;\n  padding: 18px 16px;\n  overflow-y: auto;\n}\n.period-editor-footer[data-v-75cf371a] {\n  flex-shrink: 0;\n}\n.period-edit-save-btn[data-v-75cf371a] {\n  width: 100%;\n  border: none;\n  background: #51a95b;\n  align-self: flex-end;\n  color: #f2f3fd;\n  border-bottom-left-radius: 2px;\n  border-bottom-right-radius: 2px;\n  font-family: \"league Spartan\";\n  font-size: 1.1rem;\n  padding: 8px;\n}\n.group-box[data-v-75cf371a] {\n  display: flex;\n  padding: 12px;\n  border: 1px solid #b1b4cd;\n  border-radius: 4px;\n}\n.new-recur-input[data-v-75cf371a] {\n  display: flex;\n  background: white;\n  padding: 6px 18px;\n  justify-content: space-between;\n  border: 1px solid #b1b4cd;\n  border-radius: 4px;\n}\n.new-recur-input > div[data-v-75cf371a]:last-child {\n    padding-left: 18px;\n}\n.recur-input[data-v-75cf371a] {\n  display: flex;\n  background: white;\n  padding: 8px 18px;\n  justify-content: space-between;\n  border: 1px solid #b1b4cd;\n  border-radius: 4px;\n  margin-bottom: 12px;\n}\n.recur-input > div[data-v-75cf371a]:last-child {\n    padding-left: 18px;\n    display: flex;\n    align-items: center;\n}\n.recur-label[data-v-75cf371a] {\n  font-size: 0.8rem;\n}\n.recur-preview[data-v-75cf371a] {\n  display: flex;\n  background: white;\n  justify-content: space-between;\n  border: 1px solid #b1b4cd;\n  border-radius: 4px;\n  margin-left: 12px;\n  min-width: 300px;\n  flex-grow: 1;\n}\n", ""]);

// exports


/***/ }),

/***/ "lPPF":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.mask[data-v-04679dd0] {\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.body[data-v-04679dd0] {\n  width: 60vw;\n  min-width: 800px;\n  background: #f2f3fd;\n  padding: 12px 32px;\n  max-height: 80vh;\n  overflow-y: auto;\n}\n", ""]);

// exports


/***/ }),

/***/ "mqVw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _session = __webpack_require__("PSx8");

var _session2 = _interopRequireDefault(_session);

var _signup = __webpack_require__("DBS9");

var _signup2 = _interopRequireDefault(_signup);

var _login = __webpack_require__("K31e");

var _login2 = _interopRequireDefault(_login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    component: { default: "login" }
  },
  data: function data() {
    return {
      session: _session2.default
    };
  },

  watch: {
    "session.contents": function sessionContents(contents, prev) {
      // if we went from not authed to authed, redirect to /
      if (contents && !prev) {
        this.$router.push("/");
      }
    }
  },
  components: {
    signup: _signup2.default,
    login: _login2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "nDGq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__("dWup");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63fc1178_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__("i5LY");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("KUeH")
  __webpack_require__("9Cbw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63fc1178"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63fc1178_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/event/home.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-63fc1178", Component.options)
  } else {
    hotAPI.reload("data-v-63fc1178", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "nUwj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mask",
      on: {
        click: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.close($event)
        }
      }
    },
    [
      _c("div", { staticClass: "body" }, [
        _c("h4", [_vm._v("First name")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.firstName,
              expression: "firstName"
            }
          ],
          staticClass: "dark",
          attrs: { type: "text" },
          domProps: { value: _vm.firstName },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.firstName = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c("h4", [_vm._v("Email")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.email,
              expression: "email"
            }
          ],
          staticClass: "dark",
          attrs: { type: "text" },
          domProps: { value: _vm.email },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.email = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c("h4", [_vm._v("Phone")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.phone,
              expression: "phone"
            }
          ],
          staticClass: "dark",
          attrs: { type: "text" },
          domProps: { value: _vm.phone },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.phone = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c("div", [
          _c("input", {
            staticClass: "dark",
            attrs: { type: "button", value: "create" },
            on: {
              click: function($event) {
                _vm.submit()
              }
            }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d86e4e0a", esExports)
  }
}

/***/ }),

/***/ "o7P2":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9Geh");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("355459fa", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d86e4e0a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./attendeeCreate.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d86e4e0a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./attendeeCreate.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "oY/8":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("GIKM");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("21d1024f", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-467a34bd\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-467a34bd\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "pXi0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v(" My Profile")]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.user.user.firstName))]),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.user.user.lastName))]),
      _vm._v(" "),
      _c("h2", [_vm._v(" Emails: ")]),
      _vm._v(" "),
      _vm._l(_vm.user.emails, function(e) {
        return _c("div", { key: e.address }, [_vm._v(_vm._s(e.address))])
      }),
      _vm._v(" "),
      _c("h2", [_vm._v(" Organizations: ")]),
      _vm._v(" "),
      _vm._l(_vm.user.organizations, function(org) {
        return _c("div", { key: org.organization_id }, [
          _c("hr"),
          _vm._v(" "),
          _c("div", [_c("h3", [_vm._v(_vm._s(org.name))])]),
          _vm._v(" "),
          _c("div", [
            _c(
              "button",
              {
                staticClass: "btn-secondary",
                on: {
                  click: function($event) {
                    _vm.createInvite(org.organization_id)
                  }
                }
              },
              [_vm._v("Create Invite")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-secondary",
                on: {
                  click: function($event) {
                    _vm.deleteOrganization(org.organization_id)
                  }
                }
              },
              [_vm._v("Delete")]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("h3", [_vm._v("invites:")]),
              _vm._v(" "),
              _vm._l(org.invites, function(invite) {
                return _c("div", { key: invite }, [_vm._v(_vm._s(invite))])
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("hr")
        ])
      }),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.newOrgName,
              expression: "newOrgName"
            }
          ],
          attrs: { type: "text" },
          domProps: { value: _vm.newOrgName },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.newOrgName = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn-secondary",
            on: {
              click: function($event) {
                _vm.createOrganization(_vm.newOrgName)
              }
            }
          },
          [_vm._v("Create Organization")]
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.inviteCode,
              expression: "inviteCode"
            }
          ],
          attrs: { type: "text" },
          domProps: { value: _vm.inviteCode },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.inviteCode = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn-secondary",
            on: {
              click: function($event) {
                _vm.joinOrganization(_vm.inviteCode)
              }
            }
          },
          [_vm._v("Join Organization")]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d0b1749", esExports)
  }
}

/***/ }),

/***/ "pg1t":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("UtL+");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("6cc0f867", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2bc7ec38\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./attendees.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2bc7ec38\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./attendees.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "pimq":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("J9h5");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("11dac740", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-56bbef28\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./signup.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-56bbef28\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./signup.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "qQYN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboard-container" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "body" }, [
      _c("h2", [_vm._v("My Events:")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "event-container" },
        [
          _vm._l(_vm.events, function(event) {
            return _c(
              "router-link",
              { key: event.id, attrs: { to: "/event/" + event.id } },
              [
                _c("div", { staticClass: "event-card" }, [
                  _c("h4", [_vm._v(_vm._s(event.name))])
                ])
              ]
            )
          }),
          _vm._v(" "),
          _c("router-link", { attrs: { to: "/eventcreate" } }, [
            _c("div", { staticClass: "event-card" }, [
              _c("h4", [_vm._v("Create Event")])
            ])
          ])
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dashboard-header" }, [
      _c("div", { staticClass: "header-upper" }, [
        _c("h2", [_vm._v("COMPENDIUM")]),
        _vm._v(" "),
        _c("div", { staticClass: "profile-btn" }, [
          _c("i", { staticClass: "fas fa-user-circle" }),
          _vm._v(" "),
          _c("i", { staticClass: "fas fa-chevron-down" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "header-lower" }, [
        _c("span", [_vm._v("My Team")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52077837", esExports)
  }
}

/***/ }),

/***/ "s+vn":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Iq/D");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("bce00824", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-48495f08\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./expandButton.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-48495f08\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../node_modules/sass-resources-loader/lib/loader.js?{\"resources\":[\"/usr/src/app/src/assets/_include-media.scss\",\"/usr/src/app/src/assets/palette.scss\"]}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./expandButton.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "sgeZ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.editor-body[data-v-067a7d6d] {\n  background: #f2f3fd;\n  color: black;\n  flex-grow: 1;\n}\n.detail-body[data-v-067a7d6d] {\n  color: #2a2e51;\n  display: flex;\n  flex-direction: row;\n  flex-grow: 1;\n}\n.main-section[data-v-067a7d6d] {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n}\n.details-section[data-v-067a7d6d] {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n}\n.right-section[data-v-067a7d6d] {\n  width: 550px;\n  display: flex;\n  flex-direction: column;\n  margin-left: 32px;\n}\n.brand-container[data-v-067a7d6d] {\n  border: 1px solid #2a2e51;\n  padding: 12px;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n}\n.brand-preview[data-v-067a7d6d] {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n}\n.brand-preview-body[data-v-067a7d6d] {\n  border: 1px solid #2a2e51;\n  flex-grow: 1;\n}\n", ""]);

// exports


/***/ }),

/***/ "t0kG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      !_vm.session.contents && _vm.showLoginPrompt
        ? _c("login")
        : _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ef48958", esExports)
  }
}

/***/ }),

/***/ "tLaR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("NV4f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_467a34bd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("wDjA");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("oY/8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-467a34bd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_467a34bd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/event/index.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-467a34bd", Component.options)
  } else {
    hotAPI.reload("data-v-467a34bd", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "tTI2":
/***/ (function(module, exports) {

module.exports = {"apiBaseUrl":"https://api.development.capitolairships.com/","flinkLibraryUrl":"https://api.development.capitolairships.com/client.js"}

/***/ }),

/***/ "vAWj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "body" },
    [
      _c("h2", [_vm._v("Let's Get Started!")]),
      _vm._v(" "),
      _c("h3", [_vm._v("Tell us a bit about your event:")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.eventName,
            expression: "eventName"
          }
        ],
        attrs: { type: "text", placeholder: "Event Name" },
        domProps: { value: _vm.eventName },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.eventName = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("v-date-picker", {
        attrs: { mode: "range", "is-double-paned": "", attributes: _vm.attrs },
        model: {
          value: _vm.eventRange,
          callback: function($$v) {
            _vm.eventRange = $$v
          },
          expression: "eventRange"
        }
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "button", value: "next" },
        on: {
          click: function($event) {
            _vm.save()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74bc6182", esExports)
  }
}

/***/ }),

/***/ "vUcl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["expanded"],
  data: function data() {
    return {
      bodyVisible: false
    };
  }
};

/***/ }),

/***/ "wDjA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboard-container" }, [
    _c("div", { staticClass: "dashboard-header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "header-lower" }, [
        _c(
          "span",
          [
            _c("router-link", { attrs: { to: "/dashboard" } }, [
              _vm._v("My Team")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c("span", { staticClass: "far fa-chevron-double-right" }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.event.name))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "header-nav" }, [
        _c(
          "div",
          { class: _vm.currentRoute === "home" ? "selected" : null },
          [_c("router-link", { attrs: { to: "home" } }, [_vm._v("Home")])],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { class: _vm.currentRoute === "details" ? "selected" : null },
          [
            _c("router-link", { attrs: { to: "details" } }, [_vm._v("Details")])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { class: _vm.currentRoute === "sessions" ? "selected" : null },
          [
            _c("router-link", { attrs: { to: "sessions" } }, [
              _vm._v("Sessions")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { class: _vm.currentRoute === "attendees" ? "selected" : null },
          [
            _c("router-link", { attrs: { to: "attendees" } }, [
              _vm._v("Attendees")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c("div", [_vm._v("Settings")])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "body" }, [_c("router-view")], 1)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-upper" }, [
      _c("h2", [_vm._v("COMPENDIUM")]),
      _vm._v(" "),
      _c("div", { staticClass: "profile-btn" }, [
        _c("i", { staticClass: "fas fa-user-circle" }),
        _vm._v(" "),
        _c("i", { staticClass: "fas fa-chevron-down" })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-467a34bd", esExports)
  }
}

/***/ }),

/***/ "wL8c":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.event-container[data-v-52077837] {\n  display: flex;\n}\n.event-card[data-v-52077837] {\n  height: 140px;\n  width: 180px;\n  background: white;\n  margin: 0px 12px;\n  border-radius: 4px;\n  padding: 12px;\n  box-shadow: 1px 2px 2px rgba(0, 0, 0, 0.15);\n  color: #2a2e51;\n}\n.event-card h4[data-v-52077837] {\n    margin: 0px;\n}\n.dashboard-container[data-v-52077837] {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n.dashboard-header[data-v-52077837] {\n  flex-shrink: 0;\n  background: white;\n  color: #2a2e51;\n  border-bottom: 1px solid #b1b4cd;\n  border-top: 6px solid #2b8588;\n}\n.dashboard-header .profile-btn[data-v-52077837] {\n    color: #fb8609;\n    padding: 8px 16px;\n    border-radius: 4px;\n    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);\n    font-size: 2rem;\n}\n.dashboard-header .header-upper[data-v-52077837] {\n    padding: 4px 32px;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n}\n.dashboard-header .header-upper h2[data-v-52077837] {\n      letter-spacing: 6px;\n}\n.dashboard-header .header-lower[data-v-52077837] {\n    margin-top: 8px;\n    margin-bottom: 24px;\n    font-weight: 800;\n    font-size: 2.2rem;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n}\n.dashboard-header .header-lower > span[data-v-52077837] {\n      margin: 0px 24px;\n}\n.dashboard-header .header-nav[data-v-52077837] {\n    margin-top: 48px;\n    font-size: 1.2rem;\n    font-weight: 800;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n}\n.dashboard-header .header-nav > div[data-v-52077837] {\n      margin: 0px 30px;\n      padding: 0px 24px;\n}\n.dashboard-header .header-nav > div[data-v-52077837]:hover {\n      color: #2b8588;\n      border-bottom: 6px solid #2b8588;\n}\n.dashboard-header .header-nav .selected[data-v-52077837] {\n      color: #2b8588;\n      border-bottom: 6px solid #2b8588;\n}\n.body[data-v-52077837] {\n  background: #f2f3fd;\n  color: #2a2e51;\n  flex-grow: 1;\n  padding: 20px 60px;\n}\n", ""]);

// exports


/***/ }),

/***/ "wqBJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _session = __webpack_require__("PSx8");

var _session2 = _interopRequireDefault(_session);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      session: _session2.default
    };
  },

  methods: {
    logout: function logout() {
      var _this = this;

      this.$store.dispatch("users/logout").then(function () {
        console.log(_this.$route);
        _this.$router.push("/login");
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "x7I3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notificationList_vue__ = __webpack_require__("k2mo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notificationList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notificationList_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notificationList_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notificationList_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab78508e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notificationList_vue__ = __webpack_require__("zznA");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("AVDo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ab78508e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notificationList_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ab78508e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notificationList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/notificationList.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ab78508e", Component.options)
  } else {
    hotAPI.reload("data-v-ab78508e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "xEgl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_registration_vue__ = __webpack_require__("mqVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_registration_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_registration_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_registration_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_registration_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0db976e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_registration_vue__ = __webpack_require__("XiBC");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("FQdh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e0db976e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_registration_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0db976e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_registration_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/registration.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e0db976e", Component.options)
  } else {
    hotAPI.reload("data-v-e0db976e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "xSZb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _luxon = __webpack_require__("H9QG");

function fromJson(e) {
  return {
    name: e.name,
    id: e.id,
    details: e.details,
    start: _luxon.DateTime.fromISO(e.start),
    end: _luxon.DateTime.fromISO(e.end)
  };
}
exports.default = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    create: function create(_ref, _ref2) {
      var commit = _ref.commit,
          state = _ref.state;
      var email = _ref2.email,
          firstName = _ref2.firstName,
          lastName = _ref2.lastName,
          password = _ref2.password;

      commit("loading", true, { root: true });
      return flink.user.create({
        email: email,
        firstName: firstName,
        lastName: lastName,
        password: password
      }).then(function () {
        commit("loading", false, { root: true });
      }).catch(function (err) {
        commit("loading", false, { root: true });
        throw err;
      });
    },
    emailExists: function emailExists(_ref3, _ref4) {
      var commit = _ref3.commit,
          state = _ref3.state;
      var email = _ref4.email;

      flink.user.getEmail({ email: email }).then(function (r) {
        if (r) return true;
        return false;
      });
    },
    login: function login(_ref5, _ref6) {
      var commit = _ref5.commit,
          state = _ref5.state;
      var email = _ref6.email,
          password = _ref6.password;

      commit("loading", true, { root: true });
      return flink.session.login({
        email: email,
        password: password
      }).then(function (result) {
        commit("loading", false, { root: true });
        return result;
      }).catch(function (err) {
        commit("loading", false, { root: true });
        throw err;
      });
    },
    logout: function logout(_ref7) {
      var commit = _ref7.commit,
          state = _ref7.state;

      commit("loading", true, { root: true });
      return flink.session.logout({}).then(function () {
        commit("loading", false, { root: true });
      }).catch(function (err) {
        commit("loading", false, { root: true });
        throw err;
      });
    }
  }
};

/***/ }),

/***/ "xWv6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z5BB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      formEmail: "",
      formFirstName: "",
      formLastName: "",
      formPassword: "",
      emailAlreadyRegistered: false
    };
  },

  computed: {},
  methods: {
    getEmail: function getEmail(email) {
      var _this = this;

      this.$store.dispatch("users/emailExists", { email: email }).then(function (r) {
        _this.emailAlreadyRegistered = r;
      });
    },
    createUser: function createUser() {
      var _this2 = this;

      this.$store.dispatch("users/create", {
        email: this.formEmail,
        firstName: this.formFirstName,
        lastName: this.formLastName,
        password: this.formPassword
      }).then(function (r) {
        _this2.$store.dispatch("users/login", {
          email: _this2.formEmail,
          password: _this2.formPassword
        });
      });
    }
  },
  components: {},
  mounted: function mounted() {}
};

/***/ }),

/***/ "zoXK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [_vm._v("Signup")]),
    _vm._v(" "),
    _c("form", { attrs: { action: "javascript:void(0);" } }, [
      _c("label", [_vm._v("Email Address:")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.formEmail,
            expression: "formEmail"
          }
        ],
        attrs: { type: "text" },
        domProps: { value: _vm.formEmail },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.formEmail = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-secondary",
          on: {
            click: function($event) {
              _vm.getEmail(_vm.formEmail)
            }
          }
        },
        [_vm._v("Next")]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.emailAlreadyRegistered,
              expression: "emailAlreadyRegistered"
            }
          ]
        },
        [_vm._v("Account already exists with that email address. login here")]
      )
    ]),
    _vm._v(" "),
    _c("form", { attrs: { action: "javascript:void(0);" } }, [
      _c("label", [_vm._v("First Name:")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.formFirstName,
            expression: "formFirstName"
          }
        ],
        attrs: { type: "text" },
        domProps: { value: _vm.formFirstName },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.formFirstName = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("label", [_vm._v("Last Name:")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.formLastName,
            expression: "formLastName"
          }
        ],
        attrs: { type: "text" },
        domProps: { value: _vm.formLastName },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.formLastName = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("label", [_vm._v("Password:")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.formPassword,
            expression: "formPassword"
          }
        ],
        attrs: { type: "password" },
        domProps: { value: _vm.formPassword },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.formPassword = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-secondary",
          on: {
            click: function($event) {
              _vm.createUser()
            }
          }
        },
        [_vm._v("Next")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56bbef28", esExports)
  }
}

/***/ }),

/***/ "zznA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "notification" }, [
        _c("div", { staticClass: "icon-cont" }, [
          _c("i", { staticClass: "fas fa-plus-square" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "body-cont" }, [
          _c("span", [
            _vm._v("No sessions have been added yet. "),
            _c("br"),
            _vm._v(" "),
            _c("a", { attrs: { href: "#" } }, [_vm._v("Click Here")]),
            _vm._v(" to get started.")
          ]),
          _vm._v(" "),
          _c("i", { staticClass: "fas fa-eye" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "notification" }, [
        _c("div", { staticClass: "icon-cont" }, [
          _c("i", { staticClass: "fas fa-plus-square" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "body-cont" }, [
          _c("span", [
            _vm._v("No sessions have been added yet. "),
            _c("br"),
            _vm._v(" "),
            _c("a", { attrs: { href: "#" } }, [_vm._v("Click Here")]),
            _vm._v(" to get started.")
          ]),
          _vm._v(" "),
          _c("i", { staticClass: "fas fa-eye" })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "notification" }, [
        _c("div", { staticClass: "icon-cont" }, [
          _c("i", { staticClass: "fas fa-plus-square" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "body-cont" }, [
          _c("span", [
            _vm._v("No sessions have been added yet. "),
            _c("br"),
            _vm._v(" "),
            _c("a", { attrs: { href: "#" } }, [_vm._v("Click Here")]),
            _vm._v(" to get started.")
          ]),
          _vm._v(" "),
          _c("i", { staticClass: "fas fa-eye" })
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ab78508e", esExports)
  }
}

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.ce29e61fa2bf40a268af.js